import React, { useEffect, useState } from "react";
import { Badge, Collapse, Form, ListGroup } from "react-bootstrap";
import SplitPane from "react-split-pane";
import { useParams } from "react-router-dom";
import FreezeUnfreezeHistory from "./FreezeUnfreezeHistory";
import SignatureReviewHistory from "./SignatureReviewHistory";
import FieldUpdatedHistory from "./FieldUpdatedHistory";
import FieldQueryHistory from "./FieldQuery/FieldQueryHistory";
import Swal from "sweetalert2";
import SignatureReviewAllField from "./SignatureReviewAllField";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import { FaRegPlusSquare, FaTrash } from "react-icons/fa";
import { MdOutlineAutoDelete } from "react-icons/md";
import { GoChecklist } from "react-icons/go";
import FieldErrorNotification from "./FieldErrorNotification";
import UseToggle from "../../../../Hooks/UseToggle";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";
import { studySiteDataEntryServices } from "../../../../APIServices/studySiteDataEntryServices";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import ReviewFormDataEntry from "./ReviewFormDataEntry";
import Loader from "../../../../img/Document scan.gif"
import FormDataEntryReport from "./FormDataEntryReport";
import ConnectedConditionalFormField from "./ConnectedConditionalFormField";
import AssignSubjectEventUnscheduledForm from "./AssignSubjectEventUnscheduledForm";
import { studyEventManagementServices } from "../../../../APIServices/CTMS/EventManagement/studyEventManagementServices";
import DeletedStudySubjectEventUnscheduleForm from "./DeletedStudySubjectEventUnscheduleForm";
import DeletedLogRecord from "./DeletedLogRecord";

const FormDataEntry = ({ activeTabName, tableRef, onMouseDown, handleAddNewTab }) => {
  const [formId, setFormId] = useState("");
  const [version, setVersion] = useState("");
  const [formFields, setFormFields] = useState([]);
  const [formMetadataList, setFormMetadataList] = useState([]);
  const [connectedFormFieldList, setConnectedFormFieldList] = useState([]);
  const [connectedFormFieldLoader, setConnectedFormFieldLoader] = useState(false);
  const [connectedConditionalFormList, setConnectedConditionalFormList] = useState([]);
  const [connectedConditionalFormLoader, setConnectedConditionalFormLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fieldLoading, setFieldLoading] = useState(false);
  const [dataEntryLoader, setDataEntryLoader] = useState(false);
  const [loadForm, setLoadForm] = useState(false);
  const [formName, setFormName] = useState("")
  const [formRepeat, setFormRepeat] = useState("")
  const [originalFormId, setOriginalFormId] = useState("")
  const [repeatNumber, setRepeatNumber] = useState(0)
  const [formType, setFormType] = useState("")
  const [entryType, setEntryType] = useState("")
  const [recordId, setRecordId] = useState("")
  const [recordNumber, setRecordNumber] = useState("")
  const [logRecordLoader, setLogRecordLoader] = useState(false)
  const [fieldLabel, setFieldLabel] = useState("")
  const [fieldId, setFieldId] = useState("")
  const [logRecord, setLogRecord] = useState([])
  const [dataEntryBy, setDataEntryBy] = useState("")
  const [dataRecordId, setDataRecordId] = useState("")
  const [totalDataEntry, setTotalDataEntry] = useState([])
  const [selectedFields, setSelectedFields] = useState([])
  const [selectedRadioField, setSelectedRadioField] = useState("")
  const [remark, setRemark] = useState("");
  const [password, setPassword] = useState("");
  const [querySubject, setQuerySubject] = useState("");
  const [querySubjectType, setQuerySubjectType] = useState("dynamic");
  const [queryPriority, setQueryPriority] = useState("low");
  const [queryDueDate, setQueryDueDate] = useState("");
  const [queryMessage, setQueryMessage] = useState("");
  const [reasonMessage, setReasonMessage] = useState("");
  const [responseMessage, setResponseMessage] = useState("");
  const [historyLoader, setHistoryLoader] = useState(false);
  const [freezeUnfreezeHistory, setFreezeUnfreezeHistory] = useState([])
  const [dataEntryReviewHistory, setDataEntryReviewHistory] = useState([])
  const [dataEntryReviewEligible, setDataEntryReviewEligible] = useState(false)
  const [dataEntryFormReviewHistory, setDataEntryFormReviewHistory] = useState([])
  const [dataEntryFormReviewHistoryLoader, setDataEntryFormReviewHistoryLoader] = useState(false)
  const [dataEntryQueryHistory, setDataEntryQueryHistory] = useState([])
  const [dataEntryQueryNotification, setDataEntryQueryNotification] = useState([])
  const [dataEntryQueryDiscussion, setDataEntryQueryDiscussion] = useState([])
  const [dataEntryQueryNotificationDiscussion, setDataEntryQueryNotificationDiscussion] = useState([])
  const [dataEntryQueryDiscussionLoader, setDataEntryQueryDiscussionLoader] = useState(false)
  const [updatedFieldHistory, setUpdatedFieldHistory] = useState([])
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  let { studyId } = useParams();
  // Log record delete and deleted-history are only for DBP, Live and QC modes, never SDV
  const canDeleteLogRecord = ["DBP Mode", "Live Mode", "QC Mode"].includes(StudyMode);
  let { toggle, setToggle, toggle1, setToggle1, toggle2, setToggle2, toggle3, setToggle3, toggle4, setToggle4, toggle5, setToggle5, toggle6, setToggle6, toggle7, setToggle7, toggle8, setToggle8, toggle9, setToggle9, toggle10, setToggle10, toggle11, setToggle11, toggle12, setToggle12 } = UseToggle();
  let totalOptionId = []
  const studyPermission = JSON.parse(localStorage.getItem("studyPermissionData"));
  const [saveButtonLoader, setSaveButtonLoader] = useState(false);
  const [repeatButtonLoader, setRepeatButtonLoader] = useState(false);
  const [repeatConditionalButtonLoader, setRepeatConditionalButtonLoader] = useState("");
  const [unfreezeButtonLoader, setUnfreezeButtonLoader] = useState(false);
  const [reOpenqueryButtonLoader, setReOpenQueryButtonLoader] = useState(false);
  const [buttonUnscheduledFormLoader, setButtonUnscheduledFormLoader] = useState(false);
  const [queryButtonLoader, setQueryButtonLoader] = useState(false);
  const [signedButtonLoader, setSignedButtonLoader] = useState(false);
  const [signedAllButtonLoader, setSignedAllButtonLoader] = useState(false);
  const [freezeLoader, setFreezeLoader] = useState(false);
  const [signButtonLoader, setSignButtonLoader] = useState(false);
  const [genarateButtonLoader, setGenerateButtonLoader] = useState(false);
  const [queryStatusButtonLoader, setQueryStatusButtonLoader] = useState("");
  const [queryNotificationDataLoader, setQueryNotificationDataLoader] = useState("");
  const [queryNotificationStatusButtonLoader, setQueryNotificationStatusButtonLoader] = useState(false);
  const [dataEntryQueryNotificationDiscussionLoader, setDataEntryQueryNotificationDiscussionLoader] = useState("");
  const [queryDataLoader, setQueryDataLoader] = useState(false);
  const [fieldReviewLoader, setFieldReviewLoader] = useState(false);
  const [unscheduledFormLoader, setUnscheduledFormLoader] = useState(false)
  const [deletedUnscheduledFormList, setDeletedUnscheduledFormList] = useState([])
  const [deletedLogRecordLoader, setDeletedLogRecordLoader] = useState(false)
  const [deletedLogRecordList, setDeletedLogRecordList] = useState([])
  const [deletedLogRecordForm, setDeletedLogRecordForm] = useState("")
  const [queryType, setQueryType] = useState("manual");
  const [editField, setEditField] = useState([]);

  const getNextDate = () => {
    const date = new Date();
    date.setDate(date.getDate() + 1);
    return date.toISOString().split("T")[0];
  };

  useEffect(() => {
    setTotalDataEntry([])
  }, [formId]);

  useEffect(() => {
    setQueryDueDate(getNextDate())
  }, []);

  totalDataEntry?.forEach(item => {
    if (item && typeof item === "object") {
      if (Array.isArray(item.value)) {
        item.value.forEach(v => {
          if (v?.id) totalOptionId.push(Number(v.id));
        });
      } else if (item?.id) {
        totalOptionId.push(Number(item.id));
      }
    }
  });

  const valueRanderFunction = (id) => {
    return totalDataEntry?.find(item => item.fieldId === id) || ""
  }

  const getDeletedAssignedSubjectEventUnscheduledForm = async () => {
    setUnscheduledFormLoader(true)
    let userData = {
      mode: StudyMode,
      studyId,
      siteId: activeTabName?.siteId,
      subjectId: activeTabName?.subjectId,
      schemaId: activeTabName?.schemaId,
      eventId: activeTabName?.eventId,
      status: "deleted",
    };

    if (activeTabName?.timePointUniqueId) {
      userData.timePointUniqueId =
        activeTabName?.timePointUniqueId;
    }

    let data =
      await studyEventManagementServices.getAssignedSubjectEventUnscheduledForm(
        userData
      );

    setDeletedUnscheduledFormList(data?.data || [])
    setUnscheduledFormLoader(false);
  }
  useEffect(() => {
    getDeletedAssignedSubjectEventUnscheduledForm();
  }, [activeTabName?.schemaId,
  activeTabName?.eventId,
  activeTabName?.timePointUniqueId,
  activeTabName?.siteId,
  activeTabName?.subjectId,
  ]);

  const getStudyFormListBasedonEventSchema = async () => {
    setLoading(true);
    let data = await studySiteDataEntryServices.getStudyFormListBasedonEventSchema(
      studyId,
      activeTabName?.siteId,
      activeTabName?.subjectId || "no",
      activeTabName?.schemaId,
      activeTabName?.eventId,
      activeTabName?.timePointUniqueId || "no",
      activeTabName?.type,
      activeTabName?.viewType,
      activeTabName?.repeatEventId || "no",
      activeTabName?.repeatTimePointId || "no",
      StudyMode
    );
    if (data === "AbortError") {
      setLoading(true);
    } else {
      setFormMetadataList(data?.data || []);
      setLoading(false)
    }
  };

  const getStudyLevelFormFieldsByVersion = async (e) => {
    setFieldLoading(true);
    let data = await studyLevelFormManagementServices.getStudyLevelFormFieldsByVersion(
      studyId,
      originalFormId,
      version
    );
    if (data === "AbortError") {
      setFieldLoading(true);
    } else {
      if (loadForm) {
        setFormFields(data?.data?.formFields || []);
      } else {
        setFormFields([]);
      }
      setFieldLoading(false)
    }
  };

  useEffect(() => {
    if (activeTabName) {
      getStudyFormListBasedonEventSchema();
    }
  }, [activeTabName?.eventId, activeTabName?.repeatEventId, activeTabName?.timePointUniqueId, activeTabName?.repeatTimePointId]);

  const getStudySubjectDataEntry = async () => {
    setDataEntryLoader(true)
    let userData = {}
    userData.studyId = studyId
    userData.siteId = activeTabName?.siteId
    userData.subjectId = activeTabName?.subjectId || "no"
    userData.schemaId = activeTabName?.schemaId
    userData.eventId = activeTabName?.eventId
    if (activeTabName?.timePointUniqueId) {
      userData.timePointUniqueId = activeTabName?.timePointUniqueId
    }
    userData.formId = formId
    userData.originalFormId = originalFormId
    userData.formVersion = version
    userData.formType = formType
    userData.recordId = recordId
    userData.dataEntryType = entryType
    userData.mode = StudyMode
    if (activeTabName?.repeatEventId) {
      userData.repeatEventId = activeTabName?.repeatEventId
    }
    if (activeTabName?.repeatTimePointId) {
      userData.repeatTimePointId = activeTabName?.repeatTimePointId
    }
    let data = await studySiteDataEntryServices.getStudySubjectDataEntry(userData)
    if (data === "AbortError") {
      setDataEntryLoader(true);
    } else {
      setTotalDataEntry(data?.data || [])
      setDataEntryBy(data?.dataEntryBy || "")
      setDataRecordId(data?.dataRecordId)
      setDataEntryLoader(false)
    }
  }

  const getStudyConnectedFormFields = async () => {
    setConnectedFormFieldLoader(true)
    let userData = {}
    userData.studyId = studyId
    userData.siteId = activeTabName?.siteId
    userData.subjectId = activeTabName?.subjectId
    userData.schemaId = activeTabName?.schemaId
    userData.eventId = activeTabName?.eventId
    if (activeTabName?.timePointUniqueId) {
      userData.timePointUniqueId = activeTabName?.timePointUniqueId
    }
    userData.targetFormId = formId
    userData.targetFormVersion = version
    userData.targetFormType = formType
    userData.targetDataEntryType = entryType
    if (formType === "log") {
      userData.targetRecordId = Number(recordId)
    } else {
      userData.targetRecordId = Number(dataRecordId)
    }
    userData.mode = StudyMode
    if (activeTabName?.repeatEventId) {
      userData.repeatEventId = activeTabName?.repeatEventId
    }
    if (activeTabName?.repeatTimePointId) {
      userData.repeatTimePointId = activeTabName?.repeatTimePointId
    }
    let data = await studySiteDataEntryServices.getStudyConnectedFormFields(userData)
    if (data === "AbortError") {
      setConnectedFormFieldLoader(true);
    } else {
      setConnectedFormFieldList(data?.data || [])
      setConnectedFormFieldLoader(false)
    }
  }

  const getStudyConnectedFormList = async () => {
    setConnectedConditionalFormLoader(true)
    let userData = {}
    userData.studyId = studyId
    userData.siteId = activeTabName?.siteId
    userData.subjectId = activeTabName?.subjectId
    userData.schemaId = activeTabName?.schemaId
    userData.eventId = activeTabName?.eventId
    if (activeTabName?.timePointUniqueId) {
      userData.timePointUniqueId = activeTabName?.timePointUniqueId
    }
    userData.targetFormId = originalFormId
    userData.targetFormVersion = version
    userData.targetFormType = formType
    userData.targetDataEntryType = entryType
    userData.mode = StudyMode
    if (activeTabName?.repeatEventId) {
      userData.repeatEventId = activeTabName?.repeatEventId
    }
    if (activeTabName?.repeatTimePointId) {
      userData.repeatTimePointId = activeTabName?.repeatTimePointId
    }
    let data = await studySiteDataEntryServices.getStudyConnectedFormList(userData)
    if (data === "AbortError") {
      setConnectedConditionalFormLoader(true);
    } else {
      setConnectedConditionalFormList(data?.data || [])
      setConnectedConditionalFormLoader(false)
    }
  }

  const getStudySubjectLogDataEntry = async () => {
    setLogRecordLoader(true)
    let userData = {}
    userData.studyId = studyId
    userData.siteId = activeTabName?.siteId
    userData.subjectId = activeTabName?.subjectId
    userData.schemaId = activeTabName?.schemaId
    userData.eventId = activeTabName?.eventId
    if (activeTabName?.timePointUniqueId) {
      userData.timePointUniqueId = activeTabName?.timePointUniqueId
    }
    userData.formId = formId
    userData.formVersion = version
    userData.formType = formType
    userData.dataEntryType = entryType
    userData.mode = StudyMode
    if (activeTabName?.repeatEventId) {
      userData.repeatEventId = activeTabName?.repeatEventId
    }
    if (activeTabName?.repeatTimePointId) {
      userData.repeatTimePointId = activeTabName?.repeatTimePointId
    }
    let data = await studySiteDataEntryServices.getStudySubjectLogDataEntry(userData)
    if (data === "AbortError") {
      setLogRecordLoader(true);
    } else {
      setLogRecord(data?.data || [])
      setTotalDataEntry([])
      setLogRecordLoader(false)
    }
  }

  const getLogRecordPayload = (metadata) => {
    let userData = {}
    userData.studyId = studyId
    userData.siteId = activeTabName?.siteId
    userData.subjectId = activeTabName?.subjectId
    userData.schemaId = activeTabName?.schemaId
    userData.eventId = activeTabName?.eventId
    if (activeTabName?.timePointUniqueId) {
      userData.timePointUniqueId = activeTabName?.timePointUniqueId
    }
    userData.formId = metadata?.formId
    userData.formVersion = metadata?.version || "1"
    userData.formType = metadata?.formType
    userData.dataEntryType = metadata?.type
    userData.mode = StudyMode
    if (activeTabName?.repeatEventId) {
      userData.repeatEventId = activeTabName?.repeatEventId
    }
    if (activeTabName?.repeatTimePointId) {
      userData.repeatTimePointId = activeTabName?.repeatTimePointId
    }
    return userData
  }

  const getStudySubjectDeletedLogRecordList = async (metadata) => {
    setDeletedLogRecordLoader(true)
    let data = await studySiteDataEntryServices.getStudySubjectDeletedLogRecordList(getLogRecordPayload(metadata))
    setDeletedLogRecordList(data?.data || [])
    setDeletedLogRecordLoader(false)
  }

  const handleDeletedLogRecordHistory = (metadata) => {
    setDeletedLogRecordForm(metadata)
    setToggle12()
    getStudySubjectDeletedLogRecordList(metadata)
  }

  const softDeleteRestoreStudySubjectLogRecord = async (metadata, record, type) => {
    const isDelete = type === "delete"
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${isDelete ? "Delete" : "Restore"} Record ${record?.recordNumber} of ${metadata?.formLabel}!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${isDelete ? "Delete" : "Restore"} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = getLogRecordPayload(metadata)
        userData.recordId = record?.recordId
        userData.type = type
        let data = await studySiteDataEntryServices.softDeleteRestoreStudySubjectLogRecord(userData)
        if (data?.statusCode === 200) {
          if (isDelete && recordId === record?.recordId) {
            setRecordId("")
            setRecordNumber("")
            setLoadForm(false)
            setFormFields([])
          }
          if (formId === metadata?.formId) {
            getStudySubjectLogDataEntry()
          }
          if (!isDelete) {
            getStudySubjectDeletedLogRecordList(metadata)
          }
        }
      }
    })
  }

  const getStudySubjectFormFieldQueryHistoryDataEntry = async () => {
    setQueryDataLoader(true)
    let userData = {}
    userData.studyId = studyId
    userData.siteId = activeTabName?.siteId
    userData.subjectId = activeTabName?.subjectId
    userData.schemaId = activeTabName?.schemaId
    userData.eventId = activeTabName?.eventId
    if (activeTabName?.timePointUniqueId) {
      userData.timePointUniqueId = activeTabName?.timePointUniqueId
    }
    userData.formId = formId
    userData.formVersion = version
    userData.formType = formType
    userData.recordId = recordId
    userData.dataEntryType = entryType
    userData.fieldId = fieldId
    userData.mode = StudyMode
    userData.queryType = queryType
    if (activeTabName?.repeatEventId) {
      userData.repeatEventId = activeTabName?.repeatEventId
    }
    if (activeTabName?.repeatTimePointId) {
      userData.repeatTimePointId = activeTabName?.repeatTimePointId
    }
    let data = await studySiteDataEntryServices.getStudySubjectFormFieldQueryHistoryDataEntry(userData)
    if (data === "AbortError") {
      setQueryDataLoader(true);
    } else {
      setDataEntryQueryHistory(data?.data || [])
      setDataEntryQueryDiscussion([])
      setQueryDataLoader(false)
    }
  }

  const getStudySubjectFormFieldQueryNotificationDataEntry = async () => {
    setQueryNotificationDataLoader(true)
    let userData = {}
    userData.studyId = studyId
    userData.siteId = activeTabName?.siteId
    userData.subjectId = activeTabName?.subjectId
    userData.schemaId = activeTabName?.schemaId
    userData.eventId = activeTabName?.eventId
    if (activeTabName?.timePointUniqueId) {
      userData.timePointUniqueId = activeTabName?.timePointUniqueId
    }
    userData.formId = formId
    userData.formVersion = version
    userData.formType = formType
    userData.recordId = recordId
    userData.dataEntryType = entryType
    userData.fieldId = fieldId
    userData.mode = StudyMode
    if (activeTabName?.repeatEventId) {
      userData.repeatEventId = activeTabName?.repeatEventId
    }
    if (activeTabName?.repeatTimePointId) {
      userData.repeatTimePointId = activeTabName?.repeatTimePointId
    }
    let data = await studySiteDataEntryServices.getStudySubjectFormFieldQueryNotificationDataEntry(userData)
    if (data === "AbortError") {
      setQueryNotificationDataLoader(true);
    } else {
      setDataEntryQueryNotification(data?.data || [])
      setQueryNotificationDataLoader(false)
    }
  }

  const getStudySubjectFormFieldQueryNotificationDiscussionDataEntry = async (queryId) => {
    setDataEntryQueryNotificationDiscussionLoader(true)
    let userData = {}
    userData.studyId = studyId
    userData.siteId = activeTabName?.siteId
    userData.subjectId = activeTabName?.subjectId
    userData.formId = formId
    userData.queryId = queryId
    let data = await studySiteDataEntryServices.getStudySubjectFormFieldQueryNotificationDiscussionDataEntry(userData)
    if (data === "AbortError") {
      setDataEntryQueryNotificationDiscussionLoader(true);
    } else {
      setDataEntryQueryNotificationDiscussion(data?.data || [])
      setDataEntryQueryNotificationDiscussionLoader(false)
    }
  }

  const getStudySubjectFormFieldQueryDiscussionDataEntry = async (queryId) => {
    setDataEntryQueryDiscussionLoader(true)
    let userData = {}
    userData.studyId = studyId
    userData.siteId = activeTabName?.siteId
    userData.subjectId = activeTabName?.subjectId
    userData.formId = formId
    userData.queryId = queryId
    let data = await studySiteDataEntryServices.getStudySubjectFormFieldQueryDiscussionDataEntry(userData)
    if (data === "AbortError") {
      setDataEntryQueryDiscussionLoader(true);
    } else {
      setDataEntryQueryDiscussion(data?.data || [])
      setDataEntryQueryDiscussionLoader(false)
    }
  }

  const getStudySubjectFormFreezeUnfreezeHistoryDataEntry = async (fieldId, fieldLabel) => {
    setFreezeLoader(true)
    setToggle()
    setFieldId(fieldId)
    setFieldLabel(fieldLabel)
    let userData = {}
    userData.studyId = studyId
    userData.siteId = activeTabName?.siteId
    userData.subjectId = activeTabName?.subjectId
    userData.schemaId = activeTabName?.schemaId
    userData.eventId = activeTabName?.eventId
    if (activeTabName?.timePointUniqueId) {
      userData.timePointUniqueId = activeTabName?.timePointUniqueId
    }
    userData.formId = formId
    userData.formVersion = version
    userData.formType = formType
    userData.recordId = recordId
    userData.dataEntryType = entryType
    userData.fieldId = fieldId
    userData.mode = StudyMode
    if (activeTabName?.repeatEventId) {
      userData.repeatEventId = activeTabName?.repeatEventId
    }
    if (activeTabName?.repeatTimePointId) {
      userData.repeatTimePointId = activeTabName?.repeatTimePointId
    }
    let data = await studySiteDataEntryServices.getStudySubjectFormFreezeUnfreezeHistoryDataEntry(userData)
    if (data === "AbortError") {
      setFreezeLoader(true);
    } else {
      setFreezeUnfreezeHistory(data?.data || [])
      setFreezeLoader(false)
    }
  }

  const getStudySubjectFormFieldReviewHistoryDataEntry = async (fieldId, fieldLabel) => {
    setToggle1()
    setFieldId(fieldId)
    setFieldLabel(fieldLabel)
    setFieldReviewLoader(true)
    let userData = {}
    userData.studyId = studyId
    userData.siteId = activeTabName?.siteId
    userData.subjectId = activeTabName?.subjectId
    userData.schemaId = activeTabName?.schemaId
    userData.eventId = activeTabName?.eventId
    if (activeTabName?.timePointUniqueId) {
      userData.timePointUniqueId = activeTabName?.timePointUniqueId
    }
    userData.formId = formId
    userData.formVersion = version
    userData.formType = formType
    userData.recordId = recordId
    userData.dataEntryType = entryType
    userData.fieldId = fieldId
    userData.mode = StudyMode
    if (activeTabName?.repeatEventId) {
      userData.repeatEventId = activeTabName?.repeatEventId
    }
    if (activeTabName?.repeatTimePointId) {
      userData.repeatTimePointId = activeTabName?.repeatTimePointId
    }
    let data = await studySiteDataEntryServices.getStudySubjectFormFieldReviewHistoryDataEntry(userData)
    if (data === "AbortError") {
      setFieldReviewLoader(true);
    } else {
      setDataEntryReviewHistory(data?.data || [])
      setDataEntryReviewEligible(data?.eligible || false)
      setFieldReviewLoader(false)
    }
  }

  const getStudyDataEntryFieldUpdatedHistoryList = async (fieldId, fieldLabel) => {
    setHistoryLoader(true)
    setToggle2()
    setFieldId(fieldId)
    setFieldLabel(fieldLabel)
    let userData = {}
    userData.studyId = studyId
    userData.siteId = activeTabName?.siteId
    userData.subjectId = activeTabName?.subjectId
    userData.schemaId = activeTabName?.schemaId
    userData.eventId = activeTabName?.eventId
    if (activeTabName?.timePointUniqueId) {
      userData.timePointUniqueId = activeTabName?.timePointUniqueId
    }
    userData.formId = formId
    userData.formVersion = version
    userData.formType = formType
    userData.recordId = recordId
    userData.dataEntryType = entryType
    userData.fieldId = fieldId
    userData.mode = StudyMode
    if (activeTabName?.repeatEventId) {
      userData.repeatEventId = activeTabName?.repeatEventId
    }
    if (activeTabName?.repeatTimePointId) {
      userData.repeatTimePointId = activeTabName?.repeatTimePointId
    }
    let data = await studySiteDataEntryServices.getStudyDataEntryFieldUpdatedHistoryList(userData)
    if (data === "AbortError") {
      setHistoryLoader(true);
    } else {
      setUpdatedFieldHistory(data?.data || [])
      setHistoryLoader(false)
    }
  }

  const getStudySubjectFormReviewDataEntryList = async () => {
    let userData = {}
    setDataEntryFormReviewHistoryLoader(true)
    userData.studyId = studyId
    userData.siteId = activeTabName?.siteId
    userData.subjectId = activeTabName?.subjectId
    userData.schemaId = activeTabName?.schemaId
    userData.eventId = activeTabName?.eventId
    if (activeTabName?.timePointUniqueId) {
      userData.timePointUniqueId = activeTabName?.timePointUniqueId
    }
    userData.formId = formId
    userData.formVersion = version
    userData.formType = formType
    userData.recordId = recordId
    userData.dataEntryType = entryType
    userData.mode = StudyMode
    if (activeTabName?.repeatEventId) {
      userData.repeatEventId = activeTabName?.repeatEventId
    }
    if (activeTabName?.repeatTimePointId) {
      userData.repeatTimePointId = activeTabName?.repeatTimePointId
    }
    let data = await studySiteDataEntryServices.getStudySubjectFormReviewDataEntryList(userData)
    if (data === "AbortError") {
      setDataEntryFormReviewHistoryLoader(true);
    } else {
      setDataEntryFormReviewHistory(data?.data || [])
      setDataEntryFormReviewHistoryLoader(false)
    }
  }

  useEffect(() => {
    if (formId && version) {
      getStudyLevelFormFieldsByVersion();
    }
    if (formId && version && formType && entryType) {
      getStudyLevelFormFieldsByVersion();
      if (formType === "regular") {
        setRecordId("")
        getStudySubjectDataEntry()
        if (dataRecordId) {
          getStudyConnectedFormFields()
          getStudyConnectedFormList()
        }
      } else if (formType === "log") {
        if (recordId) {
        }
        if (!recordId) {
          getStudySubjectLogDataEntry()
        }
        if (activeTabName?.autoForm === "yes") {
          getStudySubjectLogDataEntry()
        }
        if (recordId) {
          getStudyConnectedFormFields()
          getStudyConnectedFormList()
          getStudySubjectDataEntry()
        }
      }
    }
  }, [formId, version, formType, entryType, recordId, dataRecordId, loadForm]);

  useEffect(() => {
    if (queryType && fieldId && fieldLabel) {
      getStudySubjectFormFieldQueryHistoryDataEntry();
    }
  }, [queryType, fieldId, fieldLabel]);

  useEffect(() => {
    if (fieldId && fieldLabel) {
      getStudySubjectFormFieldQueryNotificationDataEntry();
    }
  }, [fieldId, fieldLabel]);

  const addNewStudySubjectDataEntry = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Submit Form Details!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Submit it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setSaveButtonLoader(true)
        const filteredDataEntry = totalDataEntry?.map(obj => {
          const {
            status,
            unitStatus,
            valueRemarkStatus,
            referenceRangeLowerLimitStatus,
            referenceRangeUpperLimitStatus,
            referenceRangeIndicatorStatus,
            clinicalSignificanceStatus,
            reviewStatus,
            unitReviewStatus,
            reviewValueRemarkStatus,
            referenceRangeLowerLimitReviewStatus,
            referenceRangeUpperLimitReviewStatus,
            referenceRangeIndicatorReviewStatus,
            clinicalSignificanceReviewStatus,
            remarkReviewStatus,
            queryStatus,
            unitQueryStatus,
            queryValueRemarkStatus,
            referenceRangeLowerLimitQueryStatus,
            referenceRangeUpperLimitQueryStatus,
            referenceRangeIndicatorQueryStatus,
            clinicalSignificanceQueryStatus,
            remarkQueryStatus,
            queryNotifyStatus,
            unitQueryNotifyStatus,
            queryNotifyValueRemarkStatus,
            referenceRangeLowerLimitQueryNotifyStatus,
            referenceRangeUpperLimitQueryNotifyStatus,
            referenceRangeIndicatorQueryNotifyStatus,
            clinicalSignificanceQueryNotifyStatus,
            remarkQueryNotifyStatus,
            ...rest
          } = obj;
          return rest;
        });
        let filteredData = filteredDataEntry?.filter(obj => Object.keys(obj)?.length > 2);
        let userData = {}
        userData.studyId = studyId
        userData.siteId = activeTabName?.siteId
        userData.subjectId = activeTabName?.subjectId
        userData.schemaId = activeTabName?.schemaId
        userData.eventId = activeTabName?.eventId
        if (activeTabName?.timePointUniqueId) {
          userData.timePointUniqueId = activeTabName?.timePointUniqueId
        }
        userData.formId = formId
        userData.originalFormId = originalFormId
        userData.formVersion = version
        userData.formType = formType
        userData.recordId = recordId
        userData.dataEntryType = entryType
        userData.mode = StudyMode
        userData.dataEntry = filteredData
        userData.editField = editField
        if (activeTabName?.repeatEventId) {
          userData.repeatEventId = activeTabName?.repeatEventId
        }
        if (activeTabName?.repeatTimePointId) {
          userData.repeatTimePointId = activeTabName?.repeatTimePointId
        }
        if (!activeTabName?.targetRecordId) {
          if (activeTabName?.targetEventId) {
            userData.targetEventId = activeTabName?.targetEventId
          }
          if (activeTabName?.targetTimePointUniqueId) {
            userData.targetTimePointUniqueId = activeTabName?.targetTimePointUniqueId
          }
          if (activeTabName?.targetFormId) {
            userData.targetFormId = activeTabName?.targetFormId
          }
          if (activeTabName?.targetFormType) {
            userData.targetFormType = activeTabName?.targetFormType
          }
          if (activeTabName?.targetDataEntryType) {
            userData.targetDataEntryType = activeTabName?.targetDataEntryType
          }
          if (activeTabName?.targetFormVersion) {
            userData.targetFormVersion = activeTabName?.targetFormVersion
          }
          if (activeTabName?.taregtFieldId) {
            userData.taregtFieldId = activeTabName?.taregtFieldId
          }
          if (activeTabName?.targetLogRecordId) {
            userData.targetLogRecordId = activeTabName?.targetLogRecordId
          }
          if (activeTabName?.actionFormId) {
            userData.actionFormId = activeTabName?.actionFormId
          }
          if (activeTabName?.actionFormVersion) {
            userData.actionFormVersion = activeTabName?.actionFormVersion
          }
          if (activeTabName?.actionOptionId) {
            userData.actionOptionId = activeTabName?.actionOptionId
          }
        }
        let data = await studySiteDataEntryServices.addNewStudySubjectDataEntry(userData)
        if (data?.statusCode === 200) {
          setEditField([])
          getStudyFormListBasedonEventSchema()
          getStudyLevelFormFieldsByVersion()
          if (formType === "regular") {
            setRecordId("")
            getStudySubjectDataEntry()
          } else if (formType === "log") {
            getStudySubjectLogDataEntry()
            if (recordId) {
              getStudySubjectDataEntry()
            }
          }
        }
      }
      setSaveButtonLoader(false)
    });
  };

  const repeatStudySubjectEventForm = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Repeat this Form!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Repeat it!`,
    }).then(async (result) => {
      setRepeatButtonLoader(true)
      if (result.isConfirmed) {
        let userData = {}
        userData.studyId = studyId
        userData.siteId = activeTabName?.siteId
        userData.subjectId = activeTabName?.subjectId
        userData.schemaId = activeTabName?.schemaId
        userData.eventId = activeTabName?.eventId
        if (activeTabName?.timePointUniqueId) {
          userData.timePointUniqueId = activeTabName?.timePointUniqueId
        }
        userData.formId = formId
        userData.formVersion = version
        userData.formType = formType
        userData.dataEntryType = entryType
        userData.mode = StudyMode
        if (activeTabName?.repeatEventId) {
          userData.repeatEventId = activeTabName?.repeatEventId
        }
        if (activeTabName?.repeatTimePointId) {
          userData.repeatTimePointId = activeTabName?.repeatTimePointId
        }
        let data = await studySiteDataEntryServices.repeatStudySubjectEventForm(userData)
        if (data?.statusCode === 200) {
          getStudyFormListBasedonEventSchema()
        }
      }
      setRepeatButtonLoader(false)
    });
  };

  const repeatStudySubjectEventConditinalForm = async (optionId, eventId, timePointUniqueId, formId, formVersion, formType, dataEntryType) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Repeat this Conditional Form!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Repeat it!`,
    }).then(async (result) => {
      setRepeatConditionalButtonLoader(optionId)
      if (result.isConfirmed) {
        let userData = {}
        userData.studyId = studyId
        userData.siteId = activeTabName?.siteId
        userData.subjectId = activeTabName?.subjectId
        userData.schemaId = activeTabName?.schemaId
        userData.eventId = eventId
        if (timePointUniqueId) {
          userData.timePointUniqueId = timePointUniqueId
        }
        userData.formId = formId
        userData.formVersion = formVersion
        userData.formType = formType
        userData.dataEntryType = dataEntryType
        userData.mode = StudyMode
        let data = await studySiteDataEntryServices.repeatStudySubjectEventForm(userData)
        if (data?.statusCode === 200) {
          getStudyConnectedFormList()
          getStudyFormListBasedonEventSchema()
        }
      }
      setRepeatConditionalButtonLoader("")
    });
  };

  const unfreezeStudySubjectFormFreezeUnfreezeHistoryDataEntry = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Unfreeze this Field!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Unfreeze it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setUnfreezeButtonLoader(true)
        let userData = {}
        userData.studyId = studyId
        userData.siteId = activeTabName?.siteId
        userData.subjectId = activeTabName?.subjectId
        userData.schemaId = activeTabName?.schemaId
        userData.eventId = activeTabName?.eventId
        if (activeTabName?.timePointUniqueId) {
          userData.timePointUniqueId = activeTabName?.timePointUniqueId
        }
        userData.formId = formId
        userData.formVersion = version
        userData.formType = formType
        userData.recordId = recordId
        userData.dataEntryType = entryType
        userData.fieldId = fieldId
        userData.remark = remark
        userData.mode = StudyMode
        userData.fieldLabelName = selectedFields
        if (activeTabName?.repeatEventId) {
          userData.repeatEventId = activeTabName?.repeatEventId
        }
        if (activeTabName?.repeatTimePointId) {
          userData.repeatTimePointId = activeTabName?.repeatTimePointId
        }
        let data = await studySiteDataEntryServices.unfreezeStudySubjectFormFreezeUnfreezeHistoryDataEntry(userData)
        if (data?.statusCode === 200) {
          setRemark("")
          setFieldId("")
          setFieldLabel("")
          setSelectedFields([])
          if (formType === "regular") {
            setRecordId("")
            getStudySubjectDataEntry()
            getStudySubjectFormFreezeUnfreezeHistoryDataEntry(fieldId, fieldLabel)
          } else if (formType === "log") {
            getStudySubjectLogDataEntry()
            if (recordId) {
              getStudySubjectDataEntry()
              getStudySubjectFormFreezeUnfreezeHistoryDataEntry(fieldId, fieldLabel)
            }
          }
        }
        setUnfreezeButtonLoader(false)
      }
    });
  };

  const signatureStudySubjectFormReviewFieldHistoryDataEntry = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Sign this form field!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Sign it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setSignedButtonLoader(true)
        let userData = {}
        userData.studyId = studyId
        userData.siteId = activeTabName?.siteId
        userData.subjectId = activeTabName?.subjectId
        userData.schemaId = activeTabName?.schemaId
        userData.eventId = activeTabName?.eventId
        if (activeTabName?.timePointUniqueId) {
          userData.timePointUniqueId = activeTabName?.timePointUniqueId
        }
        userData.formId = formId
        userData.formVersion = version
        userData.formType = formType
        userData.recordId = recordId
        userData.dataEntryType = entryType
        userData.fieldId = fieldId
        userData.remark = remark
        userData.password = password
        userData.mode = StudyMode
        userData.fieldLabelName = selectedFields
        if (activeTabName?.repeatEventId) {
          userData.repeatEventId = activeTabName?.repeatEventId
        }
        if (activeTabName?.repeatTimePointId) {
          userData.repeatTimePointId = activeTabName?.repeatTimePointId
        }
        let data = await studySiteDataEntryServices.signatureStudySubjectFormReviewFieldHistoryDataEntry(userData)
        if (data?.statusCode === 200) {
          setRemark("")
          setPassword("")
          setFieldId("")
          setFieldLabel("")
          setSelectedFields([])
          if (formType === "regular") {
            setRecordId("")
            getStudySubjectDataEntry()
            getStudySubjectFormFieldReviewHistoryDataEntry(fieldId, fieldLabel)
          } else if (formType === "log") {
            getStudySubjectLogDataEntry()
            if (recordId) {
              getStudySubjectDataEntry()
              getStudySubjectFormFieldReviewHistoryDataEntry(fieldId, fieldLabel)
            }
          }
        }
        setSignedButtonLoader(false)
      };
    })
  };

  const signatureStudySubjectFormReviewHistoryDataEntry = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Sign this form!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Sign it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setSignButtonLoader(true)
        let userData = {}
        userData.studyId = studyId
        userData.siteId = activeTabName?.siteId
        userData.subjectId = activeTabName?.subjectId
        userData.schemaId = activeTabName?.schemaId
        userData.eventId = activeTabName?.eventId
        if (activeTabName?.timePointUniqueId) {
          userData.timePointUniqueId = activeTabName?.timePointUniqueId
        }
        userData.formId = formId
        userData.formVersion = version
        userData.formType = formType
        userData.recordId = recordId
        userData.dataEntryType = entryType
        userData.mode = StudyMode
        userData.password = password
        if (activeTabName?.repeatEventId) {
          userData.repeatEventId = activeTabName?.repeatEventId
        }
        if (activeTabName?.repeatTimePointId) {
          userData.repeatTimePointId = activeTabName?.repeatTimePointId
        }
        let data = await studySiteDataEntryServices.signatureStudySubjectFormReviewHistoryDataEntry(userData)
        if (data?.statusCode === 200) {
          setPassword("")
          getStudySubjectDataEntry()
          getStudySubjectFormReviewDataEntryList()
          getStudyFormListBasedonEventSchema()
          if (recordId) {
            getStudySubjectLogDataEntry()
          }
          setToggle6()
        }
        setSignButtonLoader(false)
      };
    })
  };

  const signatureStudySubjectFormReviewAllFieldDataEntry = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Review All Fields!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Review it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setSignedAllButtonLoader(true)
        let userData = {}
        userData.studyId = studyId
        userData.siteId = activeTabName?.siteId
        userData.subjectId = activeTabName?.subjectId
        userData.schemaId = activeTabName?.schemaId
        userData.eventId = activeTabName?.eventId
        if (activeTabName?.timePointUniqueId) {
          userData.timePointUniqueId = activeTabName?.timePointUniqueId
        }
        userData.formId = formId
        userData.formVersion = version
        userData.formType = formType
        userData.recordId = recordId
        userData.dataEntryType = entryType
        userData.remark = remark
        userData.password = password
        userData.mode = StudyMode
        userData.fieldLabelName = selectedFields
        if (activeTabName?.repeatEventId) {
          userData.repeatEventId = activeTabName?.repeatEventId
        }
        if (activeTabName?.repeatTimePointId) {
          userData.repeatTimePointId = activeTabName?.repeatTimePointId
        }
        let data = await studySiteDataEntryServices.signatureStudySubjectFormReviewAllFieldDataEntry(userData)
        if (data?.statusCode === 200) {
          setToggle4()
          setRemark("")
          setPassword("")
          setSelectedFields([])
          if (formType === "regular") {
            setRecordId("")
            getStudySubjectDataEntry()
          } else if (formType === "log") {
            getStudySubjectLogDataEntry()
            if (recordId) {
              getStudySubjectDataEntry()
            }
          }
        }
        setSignedAllButtonLoader(false)
      };
    })
  };

  const generateManualQueryStudySubjectFormFieldDataEntry = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Generate Query on this field!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, generate it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setGenerateButtonLoader(true)
        let userData = {}
        userData.studyId = studyId
        userData.siteId = activeTabName?.siteId
        userData.subjectId = activeTabName?.subjectId
        userData.schemaId = activeTabName?.schemaId
        userData.eventId = activeTabName?.eventId
        if (activeTabName?.timePointUniqueId) {
          userData.timePointUniqueId = activeTabName?.timePointUniqueId
        }
        userData.formId = formId
        userData.formVersion = version
        userData.formType = formType
        userData.recordId = recordId
        userData.dataEntryType = entryType
        userData.fieldId = fieldId
        userData.remark = remark
        userData.mode = StudyMode
        userData.fieldLabelName = selectedRadioField
        userData.subject = querySubject
        userData.subjectType = querySubjectType
        userData.message = queryMessage
        userData.priority = queryPriority
        userData.assignedTo = dataEntryBy
        userData.dueDate = queryDueDate
        if (activeTabName?.repeatEventId) {
          userData.repeatEventId = activeTabName?.repeatEventId
        }
        if (activeTabName?.repeatTimePointId) {
          userData.repeatTimePointId = activeTabName?.repeatTimePointId
        }
        let data = await studySiteDataEntryServices.generateManualQueryStudySubjectFormFieldDataEntry(userData)
        if (data?.statusCode === 200) {
          setToggle3()
          setQuerySubject("")
          setQuerySubjectType("")
          setQueryMessage("")
          setFieldId("")
          setFieldLabel("")
          setSelectedRadioField("")
          getStudyFormListBasedonEventSchema()
          if (formType === "regular") {
            setRecordId("")
            getStudySubjectDataEntry()
            getStudySubjectFormFieldQueryHistoryDataEntry()
          } else if (formType === "log") {
            getStudySubjectLogDataEntry()
            if (recordId) {
              getStudySubjectDataEntry()
              getStudySubjectFormFieldQueryHistoryDataEntry()
            }
          }
        }
        setGenerateButtonLoader(false)
      };
    })
  };

  const generateManualQueryStatusStudySubjectFormField = async (queryId, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${status === "close" ? "Close" : "Cancel"} this query!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${status === "close" ? "Close" : "Cancel"} it!`,
    }).then(async (result) => {
      setQueryStatusButtonLoader(status)
      let userData = {}
      userData.studyId = studyId
      userData.siteId = activeTabName?.siteId
      userData.subjectId = activeTabName?.subjectId
      userData.schemaId = activeTabName?.schemaId
      userData.eventId = activeTabName?.eventId
      if (activeTabName?.timePointUniqueId) {
        userData.timePointUniqueId = activeTabName?.timePointUniqueId
      }
      userData.mode = StudyMode
      userData.formId = formId
      userData.queryId = queryId
      userData.status = status
      if (activeTabName?.repeatEventId) {
        userData.repeatEventId = activeTabName?.repeatEventId
      }
      if (activeTabName?.repeatTimePointId) {
        userData.repeatTimePointId = activeTabName?.repeatTimePointId
      }
      if (status === "cancel") {
        userData.message = reasonMessage
      }
      if (result.isConfirmed) {
        let data = await studySiteDataEntryServices.generateManualQueryStatusStudySubjectFormField(userData);
        if (data?.statusCode === 200) {
          setToggle3()
          setFieldId("")
          setFieldLabel("")
          setReasonMessage("")
          getStudyFormListBasedonEventSchema()
          if (formType === "regular") {
            setRecordId("")
            getStudySubjectDataEntry()
            getStudySubjectFormFieldQueryHistoryDataEntry()
          } else if (formType === "log") {
            getStudySubjectLogDataEntry()
            if (recordId) {
              getStudySubjectDataEntry()
              getStudySubjectFormFieldQueryHistoryDataEntry()
            }
          }
        }
      }
      setQueryStatusButtonLoader("")
    });
  }

  const generateQueryNotificationStatusStudySubjectFormField = async (queryId, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Close this Notification Error!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Close it!`,
    }).then(async (result) => {
      let userData = {}
      setQueryNotificationStatusButtonLoader(true)
      userData.studyId = studyId
      userData.siteId = activeTabName?.siteId
      userData.subjectId = activeTabName?.subjectId
      userData.schemaId = activeTabName?.schemaId
      userData.eventId = activeTabName?.eventId
      if (activeTabName?.timePointUniqueId) {
        userData.timePointUniqueId = activeTabName?.timePointUniqueId
      }
      userData.mode = StudyMode
      userData.formId = formId
      userData.queryId = queryId
      userData.status = status
      if (activeTabName?.repeatEventId) {
        userData.repeatEventId = activeTabName?.repeatEventId
      }
      if (activeTabName?.repeatTimePointId) {
        userData.repeatTimePointId = activeTabName?.repeatTimePointId
      }
      if (result.isConfirmed) {
        let data = await studySiteDataEntryServices.generateQueryNotificationStatusStudySubjectFormField(userData);
        if (data?.statusCode === 200) {
          setFieldId("")
          setFieldLabel("")
          setReasonMessage("")
          getStudyFormListBasedonEventSchema()
          if (formType === "regular") {
            setRecordId("")
            getStudySubjectDataEntry()
            getStudySubjectFormFieldQueryNotificationDataEntry()
          } else if (formType === "log") {
            getStudySubjectLogDataEntry()
            if (recordId) {
              getStudySubjectDataEntry()
              getStudySubjectFormFieldQueryNotificationDataEntry(fieldId, fieldLabel)
            }
          }
        }
      } else {
        getStudySubjectFormFieldQueryNotificationDataEntry(fieldId, fieldLabel)
      }
      setToggle5()
      setQueryNotificationStatusButtonLoader(false)
    });
  }

  const queryDiscussionStudySubjectFormField = async (queryId) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Response this query!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Response it!`,
    }).then(async (result) => {
      setQueryButtonLoader(true)
      let userData = {}
      userData.studyId = studyId
      userData.siteId = activeTabName?.siteId
      userData.subjectId = activeTabName?.subjectId
      userData.formId = formId
      userData.queryId = queryId
      userData.message = responseMessage
      if (result.isConfirmed) {
        let data = await studySiteDataEntryServices.queryDiscussionStudySubjectFormField(userData);
        if (data?.statusCode === 200) {
          setResponseMessage("")
          getStudySubjectFormFieldQueryDiscussionDataEntry(queryId)
        }
      }
      setQueryButtonLoader(false)
    });
  }

  const reOpenQueryStudySubjectFormField = async (queryId) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Re-open this query!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Re-open it!`,
    }).then(async (result) => {
      setReOpenQueryButtonLoader(true)
      let userData = {}
      userData.studyId = studyId
      userData.siteId = activeTabName?.siteId
      userData.formId = formId
      userData.queryId = queryId
      userData.message = reasonMessage
      if (result.isConfirmed) {
        let data = await studySiteDataEntryServices.reOpenQueryStudySubjectFormField(userData);
        if (data?.statusCode === 200) {
          setReasonMessage("")
          getStudyFormListBasedonEventSchema()
          getStudySubjectFormFieldQueryDiscussionDataEntry(queryId)
          if (formType === "regular") {
            setRecordId("")
            getStudySubjectDataEntry()
            getStudySubjectFormFieldQueryHistoryDataEntry()
          } else if (formType === "log") {
            getStudySubjectLogDataEntry()
            if (recordId) {
              getStudySubjectDataEntry()
              getStudySubjectFormFieldQueryHistoryDataEntry()
            }
          }
        }
      }
      setReOpenQueryButtonLoader(false)
    });
  }

  useEffect(() => {
    if (activeTabName?.autoForm === "yes") {
      setFormId(activeTabName?.formId || "")
      setFormName(activeTabName?.formName || "")
      setOriginalFormId(activeTabName?.originalFormId || activeTabName?.formId || "")
      setVersion(activeTabName?.formVersion || "1")
      setFormType(activeTabName?.formType || "")
      setEntryType(activeTabName?.type || "")
      setRecordId(activeTabName?.recordId || activeTabName?.targetRecordId || "")
      if (activeTabName?.formType === "log") {
        setOpenAction(activeTabName?.formId)
      }
      setLoadForm(true)
    } else {
      setFormRepeat("")
      setRepeatNumber("")
      setRecordNumber("")
      setFormFields([])
      setFormId("")
      setFormName("")
      setOriginalFormId("")
      setVersion("1")
      setFormType("")
      setEntryType("")
      setRecordId("")
      setOpenAction("")
      setLoadForm(false)
      setTotalDataEntry([])
    }
  }, [activeTabName]);

  const softDeleteRestoreStudySubjectEventUnscheduledForm = async (type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} form on this Event!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonUnscheduledFormLoader(true);
        let userData = {
          mode: StudyMode,
          studyId,
          siteId: activeTabName?.siteId,
          subjectId: activeTabName?.subjectId,
          schemaId: activeTabName?.schemaId,
          eventId: activeTabName?.eventId,
          formId,
          formVersion: version,
          formType,
          type,
        };

        if (activeTabName?.timePointUniqueId) {
          userData.timePointUniqueId =
            activeTabName?.timePointUniqueId;
        }

        let data =
          await studyEventManagementServices.softDeleteRestoreStudySubjectEventUnscheduledForm(
            userData
          );

        if (data?.statusCode === 200) {
          getStudyFormListBasedonEventSchema();
          getDeletedAssignedSubjectEventUnscheduledForm();
          setOpenAction("")
          setFormFields([])
          setLoadForm(false)
          handleAddNewTab(
            activeTabName?.type === "specialForm"
              ? `Site: ${activeTabName?.siteName} - Subject: ${activeTabName?.subjectName} - Event: Special Event`
              : activeTabName?.timePointLabel
                ? `Site: ${activeTabName?.siteName} - Subject: ${activeTabName?.subjectName} - Event: ${activeTabName?.eventName} (${activeTabName?.timePointLabel})`
                : `Site: ${activeTabName?.siteName} - Subject: ${activeTabName?.subjectName} - Event: ${activeTabName?.eventName}`,

            "",
            activeTabName?.type === "specialForm"
              ? `viewEventSchemaFormLists_${activeTabName?.siteId}_${activeTabName?.subjectId}_${activeTabName?.subjectId}SpecialForm`
              : activeTabName?.timePointUniqueId
                ? `viewEventSchemaFormLists_${activeTabName?.siteId}_${activeTabName?.subjectId}_${activeTabName?.eventId}_${activeTabName?.repeatEventId || "repeatEventId"}_${activeTabName?.timePointUniqueId}_${activeTabName?.repeatTimePointId || "repeatTimePointId"}`
                : `viewEventSchemaFormLists_${activeTabName?.siteId}_${activeTabName?.subjectId}_${activeTabName?.eventId}_${activeTabName?.repeatEventId || "repeatEventId"}`,

            {
              siteId: activeTabName?.siteId,
              siteName: activeTabName?.siteName,
              subjectId: activeTabName?.subjectId,
              subjectName: activeTabName?.subjectName,
              schemaId: activeTabName?.schemaId,
              originalFormId: originalFormId,
              type: activeTabName?.type,
              autoForm: "yes",
              viewType: activeTabName?.viewType,
              eventId: activeTabName?.eventId,
              eventName: activeTabName?.eventName,
              timePointUniqueId: activeTabName?.timePointUniqueId
                ? String(
                  activeTabName?.timePointUniqueId
                )
                : "",
              timePointLabel: activeTabName?.timePointUniqueId
                ? activeTabName?.timePointLabel
                : "",
              repeatEventId: activeTabName?.repeatEventId
                ? String(
                  activeTabName?.repeatEventId
                )
                : "",
              repeatTimePointId: activeTabName?.repeatTimePointId
                ? String(
                  activeTabName?.repeatTimePointId
                )
                : "",
            }
          );
        }
        setButtonUnscheduledFormLoader(false);
      }
    });
  };

  const tempFieldCache = {};

  const handleNumberChange = (fieldId, type, newValue, wholeNumber, floatNumber, decimalPlaces) => {
    if (type === "value") {
      if (wholeNumber) {
        if (newValue !== "" && newValue !== "-" && !isNaN(newValue)) {
          newValue = String(Math.round(Number(newValue)));
        }
      } else if (floatNumber) {
        const regex = /^-?\d*(\.\d*)?$/;
        if (!regex.test(newValue)) return;

        if (
          decimalPlaces >= 0 &&
          newValue.includes(".") &&
          newValue.split(".")[1].length > decimalPlaces
        ) {
          newValue = Number(newValue).toFixed(decimalPlaces);
        }
      } else {
        return;
      }
    }
    setTotalDataEntry(prev => {
      const existing = prev.find(item => item.fieldId === fieldId) || {};
      const updatedItem = {
        ...existing,
        fieldId,
        type: "number",
        [type]: newValue,
      };
      const filtered = prev.filter(item => item.fieldId !== fieldId);
      const finalValue = type === "value" ? newValue : updatedItem.value;
      const finalUnit = type === "unit" ? newValue : updatedItem.unit;
      const finalUnitType = type === "unitType" ? newValue : updatedItem.unitType;

      if ((finalValue !== "" && finalValue != null) || (finalUnit !== "" && finalUnit != null) || (finalUnitType !== "" && finalUnitType != null)) {
        filtered.push(updatedItem);
      }
      return filtered;
    });
  };
  
  const handleCustomNumberChange = (fieldId, type, newValue, wholeNumber, floatNumber, decimalPlaces, disable) => {
    if (type === "value") {
      if (wholeNumber) {
        if (newValue !== "" && newValue !== "-" && !isNaN(newValue)) {
          newValue = String(Math.round(Number(newValue)));
        }
      } else if (floatNumber) {
        const regex = /^-?\d*(\.\d*)?$/;
        if (!regex.test(newValue)) return;

        if (
          decimalPlaces >= 0 &&
          newValue.includes(".") &&
          newValue.split(".")[1].length > decimalPlaces
        ) {
          newValue = Number(newValue).toFixed(decimalPlaces);
        }
      } else {
        return;
      }
    }

    if (!tempFieldCache[fieldId]) {
      const existing = totalDataEntry.find(item => item.fieldId === fieldId) || {};
      tempFieldCache[fieldId] = { ...existing, fieldId, type: "customNumber" };
    }

    tempFieldCache[fieldId][type] = newValue;

    if (disable === "yes") {
      tempFieldCache[fieldId]["clinicalSignificance"] = ""
    }

    const {
      value,
      unit,
      unitType,
      referenceRangeLowerLimit,
      referenceRangeLowerLimitEntryType,
      referenceRangeUpperLimit,
      referenceRangeUpperLimitEntryType,
      referenceRangeIndicator,
      clinicalSignificance,
      remark,
    } = tempFieldCache[fieldId];

    const hasAnyValue =
      (value != null && value !== "") ||
      (unit != null && unit !== "") ||
      (unitType != null && unitType !== "") ||
      (referenceRangeLowerLimit != null && referenceRangeLowerLimit !== "") ||
      (referenceRangeLowerLimitEntryType != null && referenceRangeLowerLimitEntryType !== "") ||
      (referenceRangeUpperLimit != null && referenceRangeUpperLimit !== "") ||
      (referenceRangeUpperLimitEntryType != null && referenceRangeUpperLimitEntryType !== "") ||
      (referenceRangeIndicator != null && referenceRangeIndicator !== "") ||
      (clinicalSignificance != null && clinicalSignificance !== "") ||
      (remark != null && remark !== "");

    setTotalDataEntry(prev => {
      const filtered = prev.filter(item => item.fieldId !== fieldId);
      if (hasAnyValue) {
        filtered.push(tempFieldCache[fieldId]);
      }
      return filtered;
    });
  };

  const handleTextChange = (fieldId, type, newValue) => {
    setTotalDataEntry(prev => {
      const existing = prev.find(item => item.fieldId === fieldId) || {};
      const updatedItem = {
        ...existing,
        fieldId,
        type: "text",
        [type]: newValue,
      };
      const filtered = prev.filter(item => item.fieldId !== fieldId);
      const finalValue = type === "value" ? newValue : updatedItem.value;
      const finalUnit = type === "unit" ? newValue : updatedItem.unit;
      const finalUnitType = type === "unitType" ? newValue : updatedItem.unitType;
      if (finalValue !== "" && finalValue != null || finalUnit !== "" && finalUnit != null || finalUnitType !== "" && finalUnitType != null) {
        filtered.push(updatedItem);
      }
      return filtered;
    });
  };

  const handleCustomTextChange = (fieldId, type, newValue, disable) => {
    if (!tempFieldCache[fieldId]) {
      const existing = totalDataEntry.find(item => item.fieldId === fieldId) || {};
      tempFieldCache[fieldId] = { ...existing, fieldId, type: "customText" };
    }

    tempFieldCache[fieldId][type] = newValue;

    if (disable === "yes") {
      tempFieldCache[fieldId]["clinicalSignificance"] = ""
    }

    const {
      value,
      unit,
      unitType,
      referenceRangeLowerLimit,
      referenceRangeLowerLimitEntryType,
      referenceRangeUpperLimit,
      referenceRangeUpperLimitEntryType,
      referenceRangeIndicator,
      clinicalSignificance,
      remark,
    } = tempFieldCache[fieldId];

    const hasAnyValue =
      (value != null && value !== "") ||
      (unit != null && unit !== "") ||
      (unitType != null && unitType !== "") ||
      (referenceRangeLowerLimit != null && referenceRangeLowerLimit !== "") ||
      (referenceRangeLowerLimitEntryType != null && referenceRangeLowerLimitEntryType !== "") ||
      (referenceRangeUpperLimit != null && referenceRangeUpperLimit !== "") ||
      (referenceRangeUpperLimitEntryType != null && referenceRangeUpperLimitEntryType !== "") ||
      (referenceRangeIndicator != null && referenceRangeIndicator !== "") ||
      (clinicalSignificance != null && clinicalSignificance !== "") ||
      (remark != null && remark !== "");

    setTotalDataEntry(prev => {
      const filtered = prev.filter(item => item.fieldId !== fieldId);
      if (hasAnyValue) {
        filtered.push(tempFieldCache[fieldId]);
      }
      return filtered;
    });
  };

  const handleDateChange = (fieldId, typeOrObject, newValue) => {
    setTotalDataEntry(prev => {
      const existing = prev.find(item => item.fieldId === fieldId) || {};
      let updatedItem = {
        ...existing,
        fieldId,
        type: "date",
      };
      if (typeof typeOrObject === 'object') {
        updatedItem = {
          ...updatedItem,
          ...typeOrObject,
        };
      } else {
        updatedItem[typeOrObject] = newValue;
      }
      const filtered = prev.filter(item => item.fieldId !== fieldId);
      const { day, month, year } = updatedItem;
      if (
        (day !== "" && day != null) ||
        (month !== "" && month != null) ||
        (year !== "" && year != null)
      ) {
        filtered.push(updatedItem);
      }
      return filtered;
    });
  };

  const handleCustomDateChange = (fieldId, typeOrObject, newValue, disable) => {
    if (!tempFieldCache[fieldId]) {
      const existing = totalDataEntry.find(item => item.fieldId === fieldId) || {};
      tempFieldCache[fieldId] = { ...existing, fieldId, type: "customDate" };
    }

    if (typeof typeOrObject === 'object') {
      tempFieldCache[fieldId] = {
        ...tempFieldCache[fieldId],
        ...typeOrObject,
      };
    } else {
      tempFieldCache[fieldId][typeOrObject] = newValue;
    }

    if (disable === "yes") {
      tempFieldCache[fieldId]["clinicalSignificance"] = ""
    }

    const {
      day,
      month,
      year,
      referenceRangeLowerLimit,
      referenceRangeLowerLimitEntryType,
      referenceRangeUpperLimit,
      referenceRangeUpperLimitEntryType,
      referenceRangeIndicator,
      clinicalSignificance,
      remark,
    } = tempFieldCache[fieldId];

    const hasAnyValue =
      (day != null && day !== "") ||
      (month != null && month !== "") ||
      (year != null && year !== "") ||
      (referenceRangeLowerLimit != null && referenceRangeLowerLimit !== "") ||
      (referenceRangeLowerLimitEntryType != null && referenceRangeLowerLimitEntryType !== "") ||
      (referenceRangeUpperLimit != null && referenceRangeUpperLimit !== "") ||
      (referenceRangeUpperLimitEntryType != null && referenceRangeUpperLimitEntryType !== "") ||
      (referenceRangeIndicator != null && referenceRangeIndicator !== "") ||
      (clinicalSignificance != null && clinicalSignificance !== "") ||
      (remark != null && remark !== "");

    setTotalDataEntry(prev => {
      const filtered = prev.filter(item => item.fieldId !== fieldId);
      if (hasAnyValue) {
        filtered.push(tempFieldCache[fieldId]);
      }
      return filtered;
    });
  };

  const handleTimeChange = (fieldId, type, newValue) => {
    setTotalDataEntry(prev => {
      const existing = prev.find(item => item.fieldId === fieldId) || {};
      const updatedItem = {
        ...existing,
        fieldId,
        type: "time",
        [type]: newValue,
      };
      const filtered = prev.filter(item => item.fieldId !== fieldId);
      const finalHour = type === "hour" ? newValue : updatedItem.hour;
      const finalMinute = type === "minute" ? newValue : updatedItem.minute;
      const finalSecond = type === "second" ? newValue : updatedItem.second;
      const finalFormat = type === "format" ? newValue : updatedItem.format;
      if (finalHour !== "" && finalHour != null || finalMinute !== "" && finalMinute != null || finalSecond !== "" && finalSecond != null || finalFormat !== "" && finalFormat != null) {
        filtered.push(updatedItem);
      }
      return filtered;
    });
  };

  const handleCustomTimeChange = (fieldId, type, newValue, disable) => {
    if (!tempFieldCache[fieldId]) {
      const existing = totalDataEntry.find(item => item.fieldId === fieldId) || {};
      tempFieldCache[fieldId] = { ...existing, fieldId, type: "customTime" };
    }

    tempFieldCache[fieldId][type] = newValue;

    if (disable === "yes") {
      tempFieldCache[fieldId]["clinicalSignificance"] = ""
    }

    const {
      hour,
      minute,
      second,
      format,
      referenceRangeLowerLimit,
      referenceRangeLowerLimitEntryType,
      referenceRangeUpperLimit,
      referenceRangeUpperLimitEntryType,
      referenceRangeIndicator,
      clinicalSignificance,
      remark,
    } = tempFieldCache[fieldId];

    const hasAnyValue =
      (hour != null && hour !== "") ||
      (minute != null && minute !== "") ||
      (second != null && second !== "") ||
      (format != null && format !== "") ||
      (referenceRangeLowerLimit != null && referenceRangeLowerLimit !== "") ||
      (referenceRangeLowerLimitEntryType != null && referenceRangeLowerLimitEntryType !== "") ||
      (referenceRangeUpperLimit != null && referenceRangeUpperLimit !== "") ||
      (referenceRangeUpperLimitEntryType != null && referenceRangeUpperLimitEntryType !== "") ||
      (referenceRangeIndicator != null && referenceRangeIndicator !== "") ||
      (clinicalSignificance != null && clinicalSignificance !== "") ||
      (remark != null && remark !== "");

    setTotalDataEntry(prev => {
      const filtered = prev.filter(item => item.fieldId !== fieldId);
      if (hasAnyValue) {
        filtered.push(tempFieldCache[fieldId]);
      }
      return filtered;
    });
  };

  const handleTextareaChange = (fieldId, newValue) => {
    setTotalDataEntry(prev => {
      const existing = prev.find(item => item.fieldId === fieldId) || {};
      const updatedItem = {
        ...existing,
        fieldId,
        type: "textarea",
        value: newValue,
      };
      const filtered = prev.filter(item => item.fieldId !== fieldId);
      if (newValue !== "" && newValue != null) {
        filtered.push(updatedItem);
      }
      return filtered;
    });
  };

  const handleRangeScoreChange = (fieldId, fieldType, type, newValue) => {
    setTotalDataEntry(prev => {
      const existing = prev.find(item => item.fieldId === fieldId) || {};
      const updatedItem = {
        ...existing,
        fieldId,
        type: fieldType,
        [type]: newValue,
      };
      const filtered = prev.filter(item => item.fieldId !== fieldId);
      const finalValue = type === "value" ? newValue : updatedItem.value;
      const finalValueRemark = type === "valueRemark" ? newValue : updatedItem.valueRemark;
      if ((finalValue !== "" && finalValue != null) ||
        (finalValueRemark !== "" && finalValueRemark != null)) {
        filtered.push(updatedItem);
      }
      return filtered;
    });
  };

  const checkConditionalFunction = (fieldId, optionId) => {
    let checkFieldConditionalId = [...new Set(formFields?.filter(item => item.id === fieldId)?.map(item => item.conditionalFields).filter(Boolean).flat())]
    let conditionalOptionId = checkFieldConditionalId.filter(item => item.includes(optionId));
    let conditionalFieldId = conditionalOptionId?.map(id => Number(id.split('_')[0]))
    if (conditionalFieldId?.length > 0) {
      return totalDataEntry?.filter(item => !conditionalFieldId?.includes(item.fieldId))
    } else {
      return [...totalDataEntry]
    }
  }

  const handleDropdownRadioChange = (fieldId, optionId, type, newValue) => {
    let finalDataEntry = checkConditionalFunction(fieldId, optionId)
    const existing = finalDataEntry?.find(item => item.fieldId === fieldId) || {};
    const updatedItem = {
      ...existing,
      fieldId,
      type: "dropdownRadio",
      [type]: newValue,
    };
    if (type === "value") {
      updatedItem.id = optionId || ""
    }
    const filtered = finalDataEntry?.filter(item => item.fieldId !== fieldId);
    const finalOptionId = type === "value" ? optionId : updatedItem.id;
    const finalValueRemark = type === "valueRemark" ? newValue : updatedItem.valueRemark;
    if ((finalOptionId !== "" && finalOptionId != null) ||
      (finalValueRemark !== "" && finalValueRemark != null)) {
      filtered.push(updatedItem);
    }
    setTotalDataEntry(filtered)
  };

  const handleScaleChange = (fieldId, optionId, type, newValue) => {
    let finalDataEntry = checkConditionalFunction(fieldId, optionId)
    const existing = finalDataEntry?.find(item => item.fieldId === fieldId) || {};
    const updatedItem = {
      ...existing,
      fieldId,
      type: "scale",
      [type]: newValue,
    };
    if (type === "value") {
      updatedItem.id = optionId
    }
    const filtered = finalDataEntry?.filter(item => item.fieldId !== fieldId);
    const finalValue = type === "value" ? newValue : updatedItem.value;
    const finalValueRemark = type === "valueRemark" ? newValue : updatedItem.valueRemark;
    if ((finalValue !== "" && finalValue != null) ||
      (finalValueRemark !== "" && finalValueRemark != null)) {
      filtered.push(updatedItem);
    }
    setTotalDataEntry(filtered)
  };

  const [fileUploadLoader, setFileUploadLoader] = useState("")
  const handleUploadChange = async (fieldId, type, newValue) => {
    let uploadedFile
    const formData = new FormData();
    if (type === "value" && newValue) {
      formData.append("studyId", studyId);
      formData.append("siteId", activeTabName?.siteId);
      formData.append("file", newValue);
      setFileUploadLoader(fieldId)
      uploadedFile = await studySiteDataEntryServices.uploadDocumentData(formData);
      setFileUploadLoader("")
    }
    const existing = totalDataEntry?.find(item => item.fieldId === fieldId) || {};
    const updatedItem = {
      ...existing,
      fieldId,
      type: "file",
      value: type === "value" ? (uploadedFile?.data || "") : existing?.value || "",
      valueRemark: type === "valueRemark" ? newValue : existing?.valueRemark || "",
    };
    const filtered = totalDataEntry.filter(item => item.fieldId !== fieldId);
    const finalValue = type === "value" ? newValue : updatedItem.value;
    const finalValueRemark = type === "valueRemark" ? newValue : updatedItem.valueRemark;
    if ((finalValue !== "" && finalValue != null) ||
      (finalValueRemark !== "" && finalValueRemark != null)) {
      filtered.push(updatedItem);
    }
    setTotalDataEntry(filtered)
  };

  const handleCustomDropdownRadioChange = (fieldId, optionId, type, newValue, disable) => {
    if (!tempFieldCache[fieldId]) {
      const base = checkConditionalFunction(fieldId, optionId)?.find(item => item.fieldId === fieldId) || {};
      tempFieldCache[fieldId] = { ...base };
    }

    tempFieldCache[fieldId] = {
      ...tempFieldCache[fieldId],
      fieldId,
      type: "customDropdownRadio",
      [type]: newValue,
    };

    if (type === "value") {
      tempFieldCache[fieldId].id = optionId;
    }

    if (disable === "yes") {
      tempFieldCache[fieldId]["clinicalSignificance"] = ""
    }

    const {
      id,
      referenceRangeLowerLimit,
      referenceRangeLowerLimitEntryType,
      referenceRangeUpperLimit,
      referenceRangeUpperLimitEntryType,
      referenceRangeIndicator,
      clinicalSignificance,
      remark,
    } = tempFieldCache[fieldId];

    const hasAnyValue =
      (id !== "" && id != null) ||
      (referenceRangeLowerLimit !== "" && referenceRangeLowerLimit != null) ||
      (referenceRangeLowerLimitEntryType !== "" && referenceRangeLowerLimitEntryType != null) ||
      (referenceRangeUpperLimit !== "" && referenceRangeUpperLimit != null) ||
      (referenceRangeUpperLimitEntryType !== "" && referenceRangeUpperLimitEntryType != null) ||
      (referenceRangeIndicator !== "" && referenceRangeIndicator != null) ||
      (clinicalSignificance !== "" && clinicalSignificance != null) ||
      (remark !== "" && remark != null);

    let finalDataEntry = checkConditionalFunction(fieldId, optionId);
    const filtered = finalDataEntry?.filter(item => item.fieldId !== fieldId) || [];

    if (hasAnyValue) {
      filtered.push(tempFieldCache[fieldId]);
    }

    setTotalDataEntry(filtered);
  };

  const handleCheckboxChange = (fieldId, optionId, type, newValue) => {
    let finalDataEntry = checkConditionalFunction(fieldId, optionId)
    const existing = finalDataEntry?.find(item => item.fieldId === fieldId) || { fieldId, value: [] };
    const updatedValueArray = Array.isArray(existing.value) ? [...existing.value] : [];
    const existingIndex = updatedValueArray.findIndex(
      item => item.id === optionId && item.value === newValue
    );
    if (existingIndex > -1) {
      updatedValueArray.splice(existingIndex, 1);
    } else {
      updatedValueArray.push({ id: optionId, value: newValue });
    }
    const updatedItem = {
      ...existing,
      fieldId,
      type: "checkbox",
      [type]: type === "value" ? updatedValueArray : newValue,
    };
    const filtered = finalDataEntry?.filter(item => item.fieldId !== fieldId);
    const finalValue = type === "value" ? updatedValueArray : updatedItem.value;
    const finalValueRemark = type === "valueRemark" ? newValue : updatedItem.valueRemark;
    if (finalValue.length > 0 || (finalValueRemark !== "" && finalValueRemark != null)) {
      filtered.push(updatedItem);
    }
    setTotalDataEntry(filtered)
  };

  const handleCustomCheckboxChange = (fieldId, optionId, type, newValue, disable) => {
    if (!tempFieldCache[fieldId]) {
      const existing = checkConditionalFunction(fieldId, optionId)?.find(item => item.fieldId === fieldId) || {
        fieldId,
        value: [],
      };
      tempFieldCache[fieldId] = { ...existing };
    }

    const updatedValueArray = Array.isArray(tempFieldCache[fieldId].value)
      ? [...tempFieldCache[fieldId].value]
      : [];

    const existingIndex = updatedValueArray.findIndex(
      (item) => item.id === optionId && item.value === newValue
    );

    if (existingIndex > -1) {
      updatedValueArray.splice(existingIndex, 1);
    } else {
      updatedValueArray.push({ id: optionId, value: newValue });
    }

    tempFieldCache[fieldId] = {
      ...tempFieldCache[fieldId],
      fieldId,
      type: "customCheckbox",
      [type]: type === "value" ? updatedValueArray : newValue,
    };

    if (disable === "yes") {
      tempFieldCache[fieldId]["clinicalSignificance"] = ""
    }

    const {
      value,
      referenceRangeLowerLimit,
      referenceRangeLowerLimitEntryType,
      referenceRangeUpperLimit,
      referenceRangeUpperLimitEntryType,
      referenceRangeIndicator,
      clinicalSignificance,
      remark,
    } = tempFieldCache[fieldId];

    const hasAnyValue =
      (Array.isArray(value) && value.length > 0) ||
      (referenceRangeLowerLimit != null && referenceRangeLowerLimit !== "") ||
      (referenceRangeLowerLimitEntryType != null && referenceRangeLowerLimitEntryType !== "") ||
      (referenceRangeUpperLimit != null && referenceRangeUpperLimit !== "") ||
      (referenceRangeUpperLimitEntryType != null && referenceRangeUpperLimitEntryType !== "") ||
      (referenceRangeIndicator != null && referenceRangeIndicator !== "") ||
      (clinicalSignificance != null && clinicalSignificance !== "") ||
      (remark != null && remark !== "");

    const finalDataEntry = checkConditionalFunction(fieldId, optionId);
    const filtered = finalDataEntry?.filter(item => item.fieldId !== fieldId) || [];

    if (hasAnyValue) {
      filtered.push(tempFieldCache[fieldId]);
    }

    setTotalDataEntry(filtered);
  };

  function convertTo24(timeStr) {
    const [time, modifier = "AM"] = timeStr.split(" ");
    let [hours, minutes, seconds] = time.split(":");

    hours = parseInt(hours, 10);
    if (modifier === "PM" && hours !== 12) hours += 12;
    if (modifier === "AM" && hours === 12) hours = 0;

    return `${hours.toString().padStart(2, "0")}:${minutes}:${seconds}`;
  }
  const [openAction, setOpenAction] = useState(false)

  const handleCheckboxEditFieldChange = (fieldId, isChecked) => {
    setEditField((prev) => {
      if (isChecked) {
        return [...prev, fieldId];
      } else {
        return prev.filter((id) => id !== fieldId);
      }
    });
  };

  const firstLine = fieldLabel?.split('\n')[0]?.replace(/<[^>]*>?/gm, '').substring(0, 50) || '';

  return (
    <>
      <SplitPane split="vertical" minSize={"20%"} className="position-relative bg-white">
        <div>
          {((StudyMode === "DBP Mode" || studyPermission?.liveUnscheduledAddForm || studyPermission?.qcUnscheduledAddForm || studyPermission?.liveUnscheduledDeleteForm || studyPermission?.qcUnscheduledDeleteForm) || !(studyPermission?.qcReadOnly || studyPermission?.liveReadOnly)) &&
            <>
              {activeTabName?.type === "unscheduledForm" &&
                <div className="hstack justify-content-between border-bottom py-1 px-2">
                  {((StudyMode === "DBP Mode" || studyPermission?.liveUnscheduledAddForm || studyPermission?.qcUnscheduledAddForm) || !(studyPermission?.qcReadOnly || studyPermission?.liveReadOnly)) &&
                    <button
                      className={`updateProfile`}
                      onClick={setToggle10}
                    >
                      Add Form
                    </button>
                  }
                  {((StudyMode === "DBP Mode" || studyPermission?.liveUnscheduledDeleteForm || studyPermission?.qcUnscheduledDeleteForm) || !(studyPermission?.qcReadOnly || studyPermission?.liveReadOnly)) &&
                    <>
                      {deletedUnscheduledFormList?.length > 0 &&
                        <button
                          className={`removeProfile`}
                          onClick={setToggle11}
                        >
                          Deleted Form
                        </button>
                      }
                    </>
                  }
                </div>
              }
            </>
          }
          <div style={{ height: "calc(100vh - 144px)" }}>
            {loading ? (
              <PageLoader />
            ) : formMetadataList?.length === 0 ? (
              <div className="hstack justify-content-center h-100">
                <NoDataFoundTable MSG={activeTabName?.type === "eventForm" ? "Event form not Assigned in this event!" : activeTabName?.type === "specialForm" ? "Special form not Assigned in this Special Event!" : "First Assign form for this Subject and Event!"} />
              </div>
            ) : (
              <div className="">
                <ListGroup className="p-2 br3">
                  {formMetadataList.map((metadata, index) => (
                    metadata?.formType === "regular" ? (
                      <ListGroup.Item action
                        title={`${metadata?.formLabel} (v${metadata?.version})`}
                        onClick={() => {
                          if (metadata?.openStatus) {
                            setFormId(metadata?.formId);
                            setOriginalFormId(metadata?.originalFormId || "");
                            setFormName(metadata?.formLabel);
                            setFormRepeat(metadata?.formRepeat);
                            setRepeatNumber(metadata?.repeat);
                            setFormType(metadata?.formType);
                            setEntryType(metadata?.type);
                            setVersion(metadata?.version || "1")
                            setLoadForm(true)
                            handleAddNewTab(
                              activeTabName?.type === "specialForm"
                                ? `Site: ${activeTabName?.siteName} - Subject: ${activeTabName?.subjectName} - Event: Special Event`
                                : activeTabName?.timePointLabel
                                  ? `Site: ${activeTabName?.siteName} - Subject: ${activeTabName?.subjectName} - Event: ${activeTabName?.eventName} (${activeTabName?.timePointLabel})`
                                  : `Site: ${activeTabName?.siteName} - Subject: ${activeTabName?.subjectName} - Event: ${activeTabName?.eventName}`,

                              "",
                              activeTabName?.type === "specialForm"
                                ? `viewEventSchemaFormLists_${activeTabName?.siteId}_${activeTabName?.subjectId}_${activeTabName?.subjectId}SpecialForm`
                                : activeTabName?.timePointUniqueId
                                  ? `viewEventSchemaFormLists_${activeTabName?.siteId}_${activeTabName?.subjectId}_${activeTabName?.eventId}_${activeTabName?.repeatEventId || "repeatEventId"}_${activeTabName?.timePointUniqueId}_${activeTabName?.repeatTimePointId || "repeatTimePointId"}`
                                  : `viewEventSchemaFormLists_${activeTabName?.siteId}_${activeTabName?.subjectId}_${activeTabName?.eventId}_${activeTabName?.repeatEventId || "repeatEventId"}`,

                              {
                                siteId: activeTabName?.siteId,
                                siteName: activeTabName?.siteName,
                                subjectId: activeTabName?.subjectId,
                                subjectName: activeTabName?.subjectName,
                                schemaId: activeTabName?.schemaId,
                                originalFormId: metadata?.originalFormId,
                                formId: metadata?.formId,
                                formName: metadata?.formLabel,
                                formVersion: metadata?.version || "1",
                                formType: metadata?.formType,
                                type: metadata?.type,
                                autoForm: "yes",
                                viewType: activeTabName?.viewType,
                                eventId: activeTabName?.eventId,
                                eventName: activeTabName?.eventName,
                                timePointUniqueId: activeTabName?.timePointUniqueId
                                  ? String(
                                    activeTabName?.timePointUniqueId
                                  )
                                  : "",
                                timePointLabel: activeTabName?.timePointUniqueId
                                  ? activeTabName?.timePointLabel
                                  : "",
                                repeatEventId: activeTabName?.repeatEventId
                                  ? String(
                                    activeTabName?.repeatEventId
                                  )
                                  : "",
                                repeatTimePointId: activeTabName?.repeatTimePointId
                                  ? String(
                                    activeTabName?.repeatTimePointId
                                  )
                                  : "",
                              }
                            );
                          }
                        }}
                        key={index}
                        style={{ cursor: metadata?.openStatus ? "pointer" : "no-drop" }}
                        className={`hstack p-0 ${formId === metadata?.formId && "selectedMenu"}`}
                      >
                        <div className="hstack justify-content-between w-100 pe-2">

                          <div className="hstack gap-2">
                            <div className={metadata?.checkDataEntry === "query" ? "bg-danger" : metadata?.checkDataEntry === "queryNotify" ? "bg-purple-subtle" : metadata?.checkDataEntry === "entry" ? "bg-warning" : metadata?.checkDataEntry === "reviewed" ? "bg-success" : metadata?.openStatus ? "bg-primary-subtle" : "bg-secondary-subtle"} style={{ minWidth: 8, minHeight: "100%", backgroundColor: "#c7d3dd" }}></div>
                            <span className={`${metadata?.openStatus ? "" : "text-secondary"}`} style={{ fontSize: 12, padding: 7 }}>{metadata?.formLabel}</span>
                          </div>
                          {metadata?.repeat > 0 &&
                            <Badge bg="primary-subtle" className="br3 text-dark mt-1" style={{ fontSize: 9 }}>R{metadata?.repeat}</Badge>
                          }
                          {activeTabName?.viewType === "noEntry" &&
                            <Badge bg="primary-subtle" className="br3 text-dark mt-1" style={{ fontSize: 9 }}>V{metadata?.version}</Badge>
                          }
                        </div>
                      </ListGroup.Item>
                    ) : (
                      <>
                        <ListGroup.Item action
                          title={`${metadata?.formLabel} (v${metadata?.version})`}
                          onClick={() => {
                            if (metadata?.openStatus) {
                              if (openAction === metadata?.formId) {
                                setOpenAction("")
                                setFormFields([])
                                setLoadForm(false)
                                handleAddNewTab(
                                  metadata?.type === "specialForm"
                                    ? `Site: ${activeTabName?.siteName} - Subject: ${activeTabName?.subjectName} - Event: Special Event`
                                    : activeTabName?.timePointLabel
                                      ? `Site: ${activeTabName?.siteName} - Subject: ${activeTabName?.subjectName} - Event: ${activeTabName?.eventName} (${activeTabName?.timePointLabel})`
                                      : `Site: ${activeTabName?.siteName} - Subject: ${activeTabName?.subjectName} - Event: ${activeTabName?.eventName}`,

                                  "",
                                  metadata?.type === "specialForm"
                                    ? `viewEventSchemaFormLists_${activeTabName?.siteId}_${activeTabName?.subjectId}_${activeTabName?.subjectId}SpecialForm`
                                    : activeTabName?.timePointUniqueId
                                      ? `viewEventSchemaFormLists_${activeTabName?.siteId}_${activeTabName?.subjectId}_${activeTabName?.eventId}_${activeTabName?.repeatEventId || "repeatEventId"}_${activeTabName?.timePointUniqueId}_${activeTabName?.repeatTimePointId || "repeatTimePointId"}`
                                      : `viewEventSchemaFormLists_${activeTabName?.siteId}_${activeTabName?.subjectId}_${activeTabName?.eventId}_${activeTabName?.repeatEventId || "repeatEventId"}`,

                                  {
                                    siteId: activeTabName?.siteId,
                                    siteName: activeTabName?.siteName,
                                    subjectId: activeTabName?.subjectId,
                                    subjectName: activeTabName?.subjectName,
                                    schemaId: activeTabName?.schemaId,
                                    originalFormId: metadata?.originalFormId,
                                    type: metadata?.type,
                                    autoForm: "yes",
                                    viewType: activeTabName?.viewType,
                                    eventId: activeTabName?.eventId,
                                    eventName: activeTabName?.eventName,
                                    timePointUniqueId: activeTabName?.timePointUniqueId
                                      ? String(
                                        activeTabName?.timePointUniqueId
                                      )
                                      : "",
                                    timePointLabel: activeTabName?.timePointUniqueId
                                      ? activeTabName?.timePointLabel
                                      : "",
                                    repeatEventId: activeTabName?.repeatEventId
                                      ? String(
                                        activeTabName?.repeatEventId
                                      )
                                      : "",
                                    repeatTimePointId: activeTabName?.repeatTimePointId
                                      ? String(
                                        activeTabName?.repeatTimePointId
                                      )
                                      : "",
                                  }
                                );
                              } else {
                                setOpenAction(metadata?.formId);
                                setFormId(metadata?.formId);
                                setOriginalFormId(metadata?.originalFormId || "");
                                setFormName(metadata?.formLabel);
                                setFormType(metadata?.formType);
                                setEntryType(metadata?.type);
                                setVersion(metadata?.version || "1")
                                setRecordId("")
                                setRecordNumber("")
                                setLoadForm(false)
                                handleAddNewTab(
                                  metadata?.type === "specialForm"
                                    ? `Site: ${activeTabName?.siteName} - Subject: ${activeTabName?.subjectName} - Event: Special Event`
                                    : activeTabName?.timePointLabel
                                      ? `Site: ${activeTabName?.siteName} - Subject: ${activeTabName?.subjectName} - Event: ${activeTabName?.eventName} (${activeTabName?.timePointLabel})`
                                      : `Site: ${activeTabName?.siteName} - Subject: ${activeTabName?.subjectName} - Event: ${activeTabName?.eventName}`,

                                  "",
                                  metadata?.type === "specialForm"
                                    ? `viewEventSchemaFormLists_${activeTabName?.siteId}_${activeTabName?.subjectId}_${activeTabName?.subjectId}SpecialForm`
                                    : activeTabName?.timePointUniqueId
                                      ? `viewEventSchemaFormLists_${activeTabName?.siteId}_${activeTabName?.subjectId}_${activeTabName?.eventId}_${activeTabName?.repeatEventId || "repeatEventId"}_${activeTabName?.timePointUniqueId}_${activeTabName?.repeatTimePointId || "repeatTimePointId"}`
                                      : `viewEventSchemaFormLists_${activeTabName?.siteId}_${activeTabName?.subjectId}_${activeTabName?.eventId}_${activeTabName?.repeatEventId || "repeatEventId"}`,

                                  {
                                    siteId: activeTabName?.siteId,
                                    siteName: activeTabName?.siteName,
                                    subjectId: activeTabName?.subjectId,
                                    subjectName: activeTabName?.subjectName,
                                    schemaId: activeTabName?.schemaId,
                                    originalFormId: metadata?.originalFormId,
                                    formId: metadata?.formId,
                                    formName: metadata?.formLabel,
                                    formVersion: metadata?.version || "1",
                                    formType: metadata?.formType,
                                    type: metadata?.type,
                                    autoForm: "yes",
                                    viewType: activeTabName?.viewType,
                                    eventId: activeTabName?.eventId,
                                    eventName: activeTabName?.eventName,
                                    timePointUniqueId: activeTabName?.timePointUniqueId
                                      ? String(
                                        activeTabName?.timePointUniqueId
                                      )
                                      : "",
                                    timePointLabel: activeTabName?.timePointUniqueId
                                      ? activeTabName?.timePointLabel
                                      : "",
                                    repeatEventId: activeTabName?.repeatEventId
                                      ? String(
                                        activeTabName?.repeatEventId
                                      )
                                      : "",
                                    repeatTimePointId: activeTabName?.repeatTimePointId
                                      ? String(
                                        activeTabName?.repeatTimePointId
                                      )
                                      : "",
                                  }
                                );
                              }
                            }
                          }}
                          key={index}
                          style={{ cursor: metadata?.openStatus ? "pointer" : "no-drop" }}
                          className={`hstack p-0 position-relative ${formId === metadata?.formId && "selectedMenu"}`}
                        >
                          <div className="hstack justify-content-between w-100">
                            <div className="hstack gap-2">
                              <div className={metadata?.checkDataEntry === "query" ? "bg-danger" : metadata?.checkDataEntry === "queryNotify" ? "bg-purple-subtle" : metadata?.checkDataEntry === "entry" ? "bg-warning" : metadata?.checkDataEntry === "reviewed" ? "bg-success" : metadata?.openStatus ? "bg-primary-subtle" : "bg-secondary-subtle"} style={{ minWidth: 8, minHeight: "100%", backgroundColor: "#c7d3dd" }}></div>
                              <span className={`${metadata?.openStatus ? "" : "text-secondary"}`} style={{ fontSize: 12, padding: 7 }}>{metadata?.formLabel}</span>
                            </div>
                            <div className="hstack gap-2">
                              {(metadata?.formType === "log" && metadata?.openStatus && canDeleteLogRecord) &&
                                <MdOutlineAutoDelete
                                  title="View Deleted Records"
                                  className="text-danger"
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    handleDeletedLogRecordHistory(metadata)
                                  }}
                                />
                              }
                              {metadata?.formId === openAction ? <IoMdArrowDropup /> : <IoMdArrowDropdown />}
                            </div>
                          </div>
                        </ListGroup.Item>
                        <Collapse in={openAction === metadata?.formId}>
                          <div>
                            {!logRecordLoader &&
                              <>
                                <ListGroup.Item
                                  action style={{ fontSize: 12, width: "-webkit-fill-available" }}
                                  title='Add New Record'
                                  className={recordId ? '' : loadForm ? "bg-primary-subtle" : ""}
                                  onClick={() => {
                                    setFormId(metadata?.formId);
                                    setOriginalFormId(metadata?.originalFormId || "");
                                    setFormName(metadata?.formLabel);
                                    setFormType(metadata?.formType);
                                    setEntryType(metadata?.type);
                                    setVersion(metadata?.version || "1")
                                    setRecordId("");
                                    setRecordNumber("")
                                    setLoadForm(true)
                                    handleAddNewTab(
                                      metadata?.type === "specialForm"
                                        ? `Site: ${activeTabName?.siteName} - Subject: ${activeTabName?.subjectName} - Event: Special Event`
                                        : activeTabName?.timePointLabel
                                          ? `Site: ${activeTabName?.siteName} - Subject: ${activeTabName?.subjectName} - Event: ${activeTabName?.eventName} (${activeTabName?.timePointLabel})`
                                          : `Site: ${activeTabName?.siteName} - Subject: ${activeTabName?.subjectName} - Event: ${activeTabName?.eventName}`,

                                      "",
                                      metadata?.type === "specialForm"
                                        ? `viewEventSchemaFormLists_${activeTabName?.siteId}_${activeTabName?.subjectId}_${activeTabName?.subjectId}SpecialForm`
                                        : activeTabName?.timePointUniqueId
                                          ? `viewEventSchemaFormLists_${activeTabName?.siteId}_${activeTabName?.subjectId}_${activeTabName?.eventId}_${activeTabName?.repeatEventId || "repeatEventId"}_${activeTabName?.timePointUniqueId}_${activeTabName?.repeatTimePointId || "repeatTimePointId"}`
                                          : `viewEventSchemaFormLists_${activeTabName?.siteId}_${activeTabName?.subjectId}_${activeTabName?.eventId}_${activeTabName?.repeatEventId || "repeatEventId"}`,

                                      {
                                        siteId: activeTabName?.siteId,
                                        siteName: activeTabName?.siteName,
                                        subjectId: activeTabName?.subjectId,
                                        subjectName: activeTabName?.subjectName,
                                        schemaId: activeTabName?.schemaId,
                                        originalFormId: metadata?.originalFormId,
                                        formId: metadata?.formId,
                                        formName: metadata?.formLabel,
                                        formVersion: metadata?.version || "1",
                                        formType: metadata?.formType,
                                        type: metadata?.type,
                                        autoForm: "yes",
                                        viewType: activeTabName?.viewType,
                                        eventId: activeTabName?.eventId,
                                        eventName: activeTabName?.eventName,
                                        timePointUniqueId: activeTabName?.timePointUniqueId
                                          ? String(
                                            activeTabName?.timePointUniqueId
                                          )
                                          : "",
                                        timePointLabel: activeTabName?.timePointUniqueId
                                          ? activeTabName?.timePointLabel
                                          : "",
                                        repeatEventId: activeTabName?.repeatEventId
                                          ? String(
                                            activeTabName?.repeatEventId
                                          )
                                          : "",
                                        repeatTimePointId: activeTabName?.repeatTimePointId
                                          ? String(
                                            activeTabName?.repeatTimePointId
                                          )
                                          : "",
                                      }
                                    );
                                  }}
                                >
                                  <FaRegPlusSquare className="mb-1" /> Add New Record
                                </ListGroup.Item>
                                {logRecord?.map(((item, index) => (
                                  <ListGroup.Item
                                    onClick={() => {
                                      setFormId(metadata?.formId);
                                      setOriginalFormId(metadata?.originalFormId || "");
                                      setFormName(metadata?.formLabel);
                                      setFormType(metadata?.formType);
                                      setEntryType(metadata?.type);
                                      setRecordId(item?.recordId || "");
                                      setVersion(metadata?.version || "1")
                                      setRecordNumber(item?.recordNumber || index + 1)
                                      setLoadForm(true)
                                      handleAddNewTab(
                                        metadata?.type === "specialForm"
                                          ? `Site: ${activeTabName?.siteName} - Subject: ${activeTabName?.subjectName} - Event: Special Event`
                                          : activeTabName?.timePointLabel
                                            ? `Site: ${activeTabName?.siteName} - Subject: ${activeTabName?.subjectName} - Event: ${activeTabName?.eventName} (${activeTabName?.timePointLabel})`
                                            : `Site: ${activeTabName?.siteName} - Subject: ${activeTabName?.subjectName} - Event: ${activeTabName?.eventName}`,

                                        "",
                                        metadata?.type === "specialForm"
                                          ? `viewEventSchemaFormLists_${activeTabName?.siteId}_${activeTabName?.subjectId}_${activeTabName?.subjectId}SpecialForm`
                                          : activeTabName?.timePointUniqueId
                                            ? `viewEventSchemaFormLists_${activeTabName?.siteId}_${activeTabName?.subjectId}_${activeTabName?.eventId}_${activeTabName?.repeatEventId || "repeatEventId"}_${activeTabName?.timePointUniqueId}_${activeTabName?.repeatTimePointId || "repeatTimePointId"}`
                                            : `viewEventSchemaFormLists_${activeTabName?.siteId}_${activeTabName?.subjectId}_${activeTabName?.eventId}_${activeTabName?.repeatEventId || "repeatEventId"}`,

                                        {
                                          siteId: activeTabName?.siteId,
                                          siteName: activeTabName?.siteName,
                                          subjectId: activeTabName?.subjectId,
                                          subjectName: activeTabName?.subjectName,
                                          schemaId: activeTabName?.schemaId,
                                          originalFormId: metadata?.originalFormId,
                                          formId: metadata?.formId,
                                          formName: metadata?.formLabel,
                                          formVersion: metadata?.version || "1",
                                          formType: metadata?.formType,
                                          recordId: item?.recordId || "",
                                          type: metadata?.type,
                                          autoForm: "yes",
                                          viewType: activeTabName?.viewType,
                                          eventId: activeTabName?.eventId,
                                          eventName: activeTabName?.eventName,
                                          timePointUniqueId: activeTabName?.timePointUniqueId
                                            ? String(
                                              activeTabName?.timePointUniqueId
                                            )
                                            : "",
                                          timePointLabel: activeTabName?.timePointUniqueId
                                            ? activeTabName?.timePointLabel
                                            : "",
                                          repeatEventId: activeTabName?.repeatEventId
                                            ? String(
                                              activeTabName?.repeatEventId
                                            )
                                            : "",
                                          repeatTimePointId: activeTabName?.repeatTimePointId
                                            ? String(
                                              activeTabName?.repeatTimePointId
                                            )
                                            : "",
                                        }
                                      );
                                    }}
                                    action
                                    title={`Record ${item?.recordNumber || index + 1}`}
                                    className={recordId === item?.recordId ?
                                      item?.checkDataEntry === "query" ? "bg-danger text-white" : item?.checkDataEntry === "queryNotify" ? "bg-purple text-white" : item?.checkDataEntry === "reviewed" ? "bg-success text-white " : "bg-warning text-white"
                                      :
                                      item?.checkDataEntry === "query" ? "bg-danger-subtle" : item?.checkDataEntry === "queryNotify" ? "bg-purple-subtle" : item?.checkDataEntry === "reviewed" ? "bg-success-subtle " : "bg-warning-subtle"
                                    }
                                    style={{ fontSize: 12, backgroundColor: "#c7d3dd" }}
                                  >
                                    <div className="hstack justify-content-between">
                                      <span><GoChecklist className="mb-1" /> Record {item?.recordNumber || index + 1}</span>
                                      {canDeleteLogRecord &&
                                        <FaTrash
                                          title={`Delete Record ${item?.recordNumber || index + 1}`}
                                          className={recordId === item?.recordId ? "text-white" : "text-danger"}
                                          style={{ fontSize: 9, cursor: "pointer", width: 9, height: 11 }}
                                          onClick={(e) => {
                                            e.stopPropagation()
                                            softDeleteRestoreStudySubjectLogRecord(metadata, { recordId: item?.recordId, recordNumber: item?.recordNumber || index + 1 }, "delete")
                                          }}
                                        />
                                      }
                                    </div>
                                  </ListGroup.Item>
                                )))}
                              </>
                            }
                          </div>
                        </Collapse>
                      </>
                    )))}
                </ListGroup>
              </div>
            )}
          </div>
        </div>
        {!formId ? (
          <div className="hstack justify-content-center h-100">
            <NoDataFoundTable MSG={"Select any form."} />
          </div>
        ) : (fieldLoading || dataEntryLoader) ? (
          <div className="hstack justify-content-center h-100">
            <img src={Loader} alt="" />
          </div>
        ) : formFields.length === 0 ? (
          <div className="hstack justify-content-center h-100">
            <NoDataFoundTable MSG={"Not any filed."} />
          </div>
        ) : (
          <FormDataEntryReport
            buttonUnscheduledFormLoader={buttonUnscheduledFormLoader}
            softDeleteRestoreStudySubjectEventUnscheduledForm={softDeleteRestoreStudySubjectEventUnscheduledForm}
            repeatConditionalButtonLoader={repeatConditionalButtonLoader}
            repeatStudySubjectEventConditinalForm={repeatStudySubjectEventConditinalForm}
            setToggle9={setToggle9}
            connectedConditionalFormList={connectedConditionalFormList}
            dataRecordId={dataRecordId}
            connectedFormFieldList={connectedFormFieldList}
            connectedFormFieldLoader={connectedFormFieldLoader}
            handleAddNewTab={handleAddNewTab}
            formName={formName}
            formType={formType}
            recordNumber={recordNumber}
            StudyMode={StudyMode}
            studyPermission={studyPermission}
            activeTabName={activeTabName}
            formRepeat={formRepeat}
            repeatNumber={repeatNumber}
            totalDataEntry={totalDataEntry}
            repeatButtonLoader={repeatButtonLoader}
            repeatStudySubjectEventForm={repeatStudySubjectEventForm}
            saveButtonLoader={saveButtonLoader}
            addNewStudySubjectDataEntry={addNewStudySubjectDataEntry}
            setToggle4={setToggle4}
            formFields={formFields}
            totalOptionId={totalOptionId}
            valueRanderFunction={valueRanderFunction}
            handleNumberChange={handleNumberChange}
            handleCustomNumberChange={handleCustomNumberChange}
            handleTextChange={handleTextChange}
            handleCustomTextChange={handleCustomTextChange}
            handleDateChange={handleDateChange}
            handleCustomDateChange={handleCustomDateChange}
            handleTimeChange={handleTimeChange}
            handleCustomTimeChange={handleCustomTimeChange}
            handleTextareaChange={handleTextareaChange}
            handleDropdownRadioChange={handleDropdownRadioChange}
            handleCustomDropdownRadioChange={handleCustomDropdownRadioChange}
            handleRangeScoreChange={handleRangeScoreChange}
            handleScaleChange={handleScaleChange}
            fileUploadLoader={fileUploadLoader}
            handleUploadChange={handleUploadChange}
            handleCheckboxChange={handleCheckboxChange}
            handleCustomCheckboxChange={handleCustomCheckboxChange}
            convertTo24={convertTo24}
            setToggle3={setToggle3}
            setFieldId={setFieldId}
            setFieldLabel={setFieldLabel}
            setToggle5={setToggle5}
            getStudySubjectFormFreezeUnfreezeHistoryDataEntry={getStudySubjectFormFreezeUnfreezeHistoryDataEntry}
            getStudySubjectFormFieldReviewHistoryDataEntry={getStudySubjectFormFieldReviewHistoryDataEntry}
            getStudyDataEntryFieldUpdatedHistoryList={getStudyDataEntryFieldUpdatedHistoryList}
            dataEntryFormReviewHistory={dataEntryFormReviewHistory}
            dataEntryFormReviewHistoryLoader={dataEntryFormReviewHistoryLoader}
            formId={formId}
            version={version}
            recordId={recordId}
            entryType={entryType}
            setToggle6={setToggle6}
            setToggle7={setToggle7}
            getStudySubjectFormReviewDataEntryList={getStudySubjectFormReviewDataEntryList}
            handleCheckboxEditFieldChange={handleCheckboxEditFieldChange}
            editField={editField}
          />
        )}
      </SplitPane>
      <FreezeUnfreezeHistory
        Show={!toggle}
        Hide={setToggle}
        Title={`${firstLine} (Freeze and Unfreeze History)`}
        freezeUnfreezeHistory={freezeUnfreezeHistory}
        tableRef={tableRef}
        freezeLoader={freezeLoader}
        onMouseDown={onMouseDown}
        remark={remark}
        setRemark={setRemark}
        fieldId={fieldId}
        formFields={formFields}
        totalDataEntry={totalDataEntry}
        setSelectedFields={setSelectedFields}
        selectedFields={selectedFields}
        unfreezeButtonLoader={unfreezeButtonLoader}
        unfreezeStudySubjectFormFreezeUnfreezeHistoryDataEntry={unfreezeStudySubjectFormFreezeUnfreezeHistoryDataEntry}
      />
      <SignatureReviewHistory
        Show={!toggle1}
        Hide={setToggle1}
        Title={`${firstLine} (Review History)`}
        fieldLabel={fieldLabel}
        dataEntryReviewHistory={dataEntryReviewHistory}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        remark={remark}
        setRemark={setRemark}
        password={password}
        setPassword={setPassword}
        fieldId={fieldId}
        formFields={formFields}
        totalDataEntry={totalDataEntry}
        setSelectedFields={setSelectedFields}
        selectedFields={selectedFields}
        signedButtonLoader={signedButtonLoader}
        fieldReviewLoader={fieldReviewLoader}
        dataEntryReviewEligible={dataEntryReviewEligible}
        signatureStudySubjectFormReviewFieldHistoryDataEntry={signatureStudySubjectFormReviewFieldHistoryDataEntry}
      />
      <SignatureReviewAllField
        Show={!toggle4}
        Hide={setToggle4}
        Title={`${formName} (SDV All Field)`}
        remark={remark}
        setRemark={setRemark}
        password={password}
        setPassword={setPassword}
        formFields={formFields}
        totalDataEntry={totalDataEntry}
        setSelectedFields={setSelectedFields}
        selectedFields={selectedFields}
        totalOptionId={totalOptionId}
        signedAllButtonLoader={signedAllButtonLoader}
        signatureStudySubjectFormReviewAllFieldDataEntry={signatureStudySubjectFormReviewAllFieldDataEntry}
      />
      <FieldQueryHistory
        Show={!toggle3}
        Hide={setToggle3}
        Title={`${firstLine} (Query History)`}
        fieldLabel={fieldLabel}
        dataEntryQueryHistory={dataEntryQueryHistory}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        querySubject={querySubject}
        setQuerySubject={setQuerySubject}
        querySubjectType={querySubjectType}
        setQuerySubjectType={setQuerySubjectType}
        queryMessage={queryMessage}
        setQueryMessage={setQueryMessage}
        reasonMessage={reasonMessage}
        setReasonMessage={setReasonMessage}
        fieldId={fieldId}
        formName={formName}
        version={version}
        formType={formType}
        formFields={formFields}
        setQueryDueDate={setQueryDueDate}
        queryDueDate={queryDueDate}
        setQueryPriority={setQueryPriority}
        queryPriority={queryPriority}
        totalDataEntry={totalDataEntry}
        setSelectedRadioField={setSelectedRadioField}
        selectedRadioField={selectedRadioField}
        dataEntryQueryDiscussion={dataEntryQueryDiscussion}
        queryDataLoader={queryDataLoader}
        dataEntryQueryDiscussionLoader={dataEntryQueryDiscussionLoader}
        setResponseMessage={setResponseMessage}
        responseMessage={responseMessage}
        queryButtonLoader={queryButtonLoader}
        genarateButtonLoader={genarateButtonLoader}
        queryStatusButtonLoader={queryStatusButtonLoader}
        reOpenqueryButtonLoader={reOpenqueryButtonLoader}
        queryType={queryType}
        setQueryType={setQueryType}
        reOpenQueryStudySubjectFormField={reOpenQueryStudySubjectFormField}
        queryDiscussionStudySubjectFormField={queryDiscussionStudySubjectFormField}
        generateManualQueryStatusStudySubjectFormField={generateManualQueryStatusStudySubjectFormField}
        getStudySubjectFormFieldQueryDiscussionDataEntry={getStudySubjectFormFieldQueryDiscussionDataEntry}
        generateManualQueryStudySubjectFormFieldDataEntry={generateManualQueryStudySubjectFormFieldDataEntry}
      />
      <FieldErrorNotification
        Show={!toggle5}
        Hide={setToggle5}
        Title={`${firstLine} (Error Notification)`}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        formName={formName}
        version={version}
        formType={formType}
        dataEntryQueryNotification={dataEntryQueryNotification}
        dataEntryQueryNotificationDiscussion={dataEntryQueryNotificationDiscussion}
        queryNotificationDataLoader={queryNotificationDataLoader}
        dataEntryQueryNotificationDiscussionLoader={dataEntryQueryNotificationDiscussionLoader}
        queryNotificationStatusButtonLoader={queryNotificationStatusButtonLoader}
        getStudySubjectFormFieldQueryNotificationDiscussionDataEntry={getStudySubjectFormFieldQueryNotificationDiscussionDataEntry}
        generateQueryNotificationStatusStudySubjectFormField={generateQueryNotificationStatusStudySubjectFormField}
      />
      <FieldUpdatedHistory
        Show={!toggle2}
        Hide={setToggle2}
        Title={`${firstLine} (Updated History)`}
        updatedFieldHistory={updatedFieldHistory}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        fieldId={fieldId}
        formFields={formFields}
        historyLoader={historyLoader}
      />
      <ReviewFormDataEntry
        Show={!toggle6}
        Hide={setToggle6}
        signButtonLoader={signButtonLoader}
        signatureStudySubjectFormReviewHistoryDataEntry={signatureStudySubjectFormReviewHistoryDataEntry}
        Title={`Review ${formName}`}
        setPassword={setPassword}
        password={password}
      />
      <ConnectedConditionalFormField
        Show={!toggle9}
        Hide={setToggle9}
        activeTabName={activeTabName}
        connectedConditionalFormList={connectedConditionalFormList}
        connectedConditionalFormLoader={connectedConditionalFormLoader}
        formId={formId}
        version={version}
        formType={formType}
        dataEntryType={entryType}
        recordId={recordId || dataRecordId}
        getStudyConnectedFormList={getStudyConnectedFormList}
        getStudyConnectedFormFields={getStudyConnectedFormFields}
        Title={`Connect Now ${formName}`}
      />
      <AssignSubjectEventUnscheduledForm
        Show={!toggle10}
        Hide={setToggle10}
        activeTabName={activeTabName}
        getStudyFormListBasedonEventSchema={getStudyFormListBasedonEventSchema}
        Title={`Assign Unscheduled Form`}
      />
      <DeletedStudySubjectEventUnscheduleForm
        Show={!toggle11}
        Hide={setToggle11}
        activeTabName={activeTabName}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        unscheduledFormLoader={unscheduledFormLoader}
        deletedUnscheduledFormList={deletedUnscheduledFormList}
        getDeletedAssignedSubjectEventUnscheduledForm={getDeletedAssignedSubjectEventUnscheduledForm}
        getStudyFormListBasedonEventSchema={getStudyFormListBasedonEventSchema}
        Title={`Deleted Unscheduled Form`}
      />
      <DeletedLogRecord
        Show={!toggle12}
        Hide={setToggle12}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        deletedLogRecordLoader={deletedLogRecordLoader}
        deletedLogRecordList={deletedLogRecordList}
        restoreStudySubjectLogRecord={(record) => softDeleteRestoreStudySubjectLogRecord(deletedLogRecordForm, record, "restore")}
        Title={`Deleted Record History of ${deletedLogRecordForm?.formLabel || "Form"}`}
      />
    </>
  );
};

export default FormDataEntry;
